// oxfmt-ignore
export default {
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.or': 'or',
  'common.select': 'Select',
  'common.messages.success': 'Success',
  'common.errors.404': 'Object not found',
  'common.errors.403': 'You do not have access to perform this action',
  'common.errors.400': 'Something went wrong, please contact 50skills',
  'common.preview.label': 'Preview',
  'common.delete.label': 'Delete',
  'common.forms.select.placeholder': 'Select...',
  'common.forms.button.save': 'Save',
  'common.forms.button.submit': 'Submit',
  'common.forms.button.remove': 'Remove',
  'common.forms.button.cancel': 'Cancel',
  'components.filefield.add': 'Add',
  'components.filefield.replace': 'Replace',
  'components.imageinput.add': 'Add image',
  'components.imageinput.replace': 'Replace image',
  'files.add': 'Upload file',
  'files.accepted': 'Accepted file types: {0}',
  'application.addnote.error': 'Adding comment failed. Please contact 50skills support.',
  'application.addnote.success': 'Comment successfully added.',
  'application.changestage.error': 'Error moving applications. Please contact 50skills support.',
  'application.changestage.success': '{0} moved to stage {1}',
  'application.chat.update.error': 'Unable to update note. Please contact 50skills support.',
  'application.chat.update.success': 'Successfully updated note.',
  'application.setassignedto.success': 'Successfully assigned {0} to {1}',
  'application.setassignedto.remove': 'Successfully removed assignment from {0}',
  'application.setassignedto.error': 'Unable to assign {0} to {1}',
  'application.grantmultifollowers.error': 'Unable to grant permissions. Please contact 50skills.',
  'application.hire.error': 'Unable to hire {0}. Please contact 50skills support.',
  'application.hire.success': 'Successfully hired {0}.',
  'application.onboard.error': 'Unable to onboard {0}. Please contact 50skills support.',
  'application.onboard.success': 'Successfully marked {0} as onboarded.',
  'application.unonboard.error': 'Unable to unmark as {0} as onboarded. Please contact 50skills support.',
  'application.unonboard.success': 'Successfully unmarked {0} as onboarded.',
  'application.keepname.error': 'Unable to update the applicant. Please contact 50skills support.',
  'application.keepname.success': 'Successfully accepted the current applicant name.',
  'application.matchname.error': 'Unable to update the applicant name. Please contact 50skills support.',
  'application.matchname.success': 'Applicant name now matches the national registry.',
  'application.reject.error': 'Unable to reject applicant. Please contact 50skills.',
  'application.reject.success.rejection': 'Successfully rejected applicant. A rejection e-mail will be sent.',
  'application.reject.success': 'Successfully rejected applicant.',
  'application.removefollower.error': 'Unable to revoke permission. Please contact 50skills support.',
  'application.removefollower.success': "Successfully revoked {0} permission from {1}'s application.",
  'application.removenote.error': 'Removing comment failed. Please contact 50skills support.',
  'application.removenote.success': 'Comment successfully removed',
  'application.removetasklist.error': 'Unable to remove checklist from application. Please contact 50skills support.',
  'application.removetasklist.success': 'Successfully removed checklist from application.',
  'application.resetreview.error': 'Unable to reset your rating. Please contact 50skills support.',
  'application.resetreview.success': 'Rating successfully reset.',
  'application.setreview.error': 'Unable to set your rating. Please contact 50skills support.',
  'application.setreview.success': 'Rating successfully set.',
  'application.store.delete.error': "Unable to delete {0}'s application. Please contact 50skills support.",
  'application.store.delete.success': "Successfully deleted {0}'s application.",
  'application.task.toggle.error.done': 'Unable to mark {0} as done',
  'application.task.toggle.error.notdone': 'Unable to mark {0} as not done',
  'application.task.toggle.success.done': 'Successfully marked {0} as done',
  'application.task.toggle.success.notdone': 'Successfully marked {0} as not done',
  'application.unreject.error': 'Unable to un-reject applicant. Please contact 50skills support.',
  'application.unreject.success': 'Applicant successfully un-rejected.',
  'application.unhire.error': 'Unable to un-hire applicant. Please contact 50skills.',
  'application.unhire.success': 'Applicant successfully un-hired.',
  'application.retract.error': 'Unable to mark applicant as retracted. Please contact 50skills.',
  'application.retract.success': 'Applicant successfully marked as retracted.',
  'application.unretract.error': 'Unable to unmark applicant as retracted. Please contact 50skills.',
  'application.unretract.success': 'Applicant successfully unmarked as retracted.',
  'application.verifyssn.error.notfound': 'Unable to find SSN / ID number in the national registry.',
  'application.verifyssn.error': 'Unable to verify SSN / ID number. Please contact 50skills support.',
  'application.verifyssn.keepormatch': 'SSN / ID number successfully verified but the name does not match the national registry record',
  'application.verifyssn.success': 'Name and SSN / ID number successfully verified.',
  'application.verifyssn.unverified': 'Unverified',
  'application.verifyssn.verified': 'Verified',
  'application.edit.ssn.success': 'Application SSN / ID number successfully updated',
  'application.edit.ssn.error': 'Unable to update application SSN / ID number. Please contact 50skills support.',
  'application.edit.header': 'Edit application',
  'changepass.submit.error': 'Unable to change password.',
  'changepass.submit.success': 'Password successfully changed. You will need to log back in with your new password.',
  'changepass.validate.pass2error': "New passwords don't match.",
  'career.update.image.success': 'Image successfully updated',
  'career.update.image.error': 'Unable to update image. Please contact 50skills support',
  'jobs.createjob': 'New job',
  'jobs.export': 'Export',
  'jobs.tabs.archived': 'Archived',
  'jobs.tabs.drafts': 'Drafts',
  'jobs.tabs.expired': 'Expired',
  'jobs.tabs.published': 'Published',
  'jobs.tabs.label': 'Job state selection',
  'jobs.archived': 'Archived',
  'edituser.create.email.error': 'The user already exists in 50skills',
  'edituser.create.error': 'Error while creating user',
  'edituser.create.success': 'User successfully created.',
  'errors.required': 'This field is required',
  'language.inSentence.en': 'English',
  'language.inSentence.is': 'Icelandic',
  'language.inSentence.pl': 'Polish',
  'language.inSentence.no': 'Norwegian',
  'language.inSentence.sv': 'Swedish',
  'language.inSentence.fr': 'French',
  'general.en': 'English',
  'general.is': 'Icelandic',
  'general.yes': 'Yes',
  'general.no': 'No',
  'helpers.defno': 'Definite no',
  'helpers.no': 'No',
  'helpers.strongyes': 'Strong yes',
  'helpers.yes': 'Yes',
  'helpers.add': 'Add file',
  'hiremodal.button.cancel': 'Cancel',
  'hiremodal.button.submit': 'Hire',
  'hiremodal.confirmtext': 'Are you sure you want to hire the candidate?',
  'hiremodal.title': 'Hire applicant',
  'retractmodal.button.cancel': 'Cancel',
  'retractmodal.button.submit': 'Mark as retracted',
  'retractmodal.confirmtext': 'Are you sure you want to mark the applicant as retracted:',
  'retractmodal.title': 'Mark applicant as retracted',
  'exportmodal.title': 'Export applicants',
  'exportmodal.exporting.number': 'Exporting {0} of {1} applicants',
  'exportmodal.exporting.filteredout': 'Filters / Selection applied',
  'exportmodal.labels.exporttype': 'Export type',
  'exportmodal.labels.headers': 'Select headers',
  'exportmodal.labels.questions': 'Application questions',
  'exportmodal.exporttype.xlsx': 'XLSX',
  'exportmodal.exporttype.csv': 'CSV',
  'exportmodal.fields.details': 'APPLICANT DETAILS',
  'exportmodal.fields.id': 'Application ID',
  'exportmodal.fields.name': 'Name',
  'exportmodal.fields.email': 'Email',
  'exportmodal.fields.phone': 'Phone',
  'exportmodal.fields.ssn': 'SSN / ID number',
  'exportmodal.fields.age': 'Age',
  'exportmodal.fields.gender': 'Gender',
  'exportmodal.fields.jobstatus': 'APPLICANT JOB STATUS',
  'exportmodal.fields.jobid': 'Job ID',
  'exportmodal.fields.jobtitle': 'Job Title',
  'exportmodal.fields.jobdepartment': 'Job Department',
  'exportmodal.fields.joblocation': 'Job Location',
  'exportmodal.fields.joblabel': 'Job Label',
  'exportmodal.fields.date': 'Date applied',
  'exportmodal.fields.is_rejected': 'Is rejected',
  'exportmodal.fields.is_notified_of_rejection': 'Is notified of rejection',
  'exportmodal.fields.date_rejected': 'Date of rejection',
  'exportmodal.fields.is_hired': 'Is hired',
  'exportmodal.fields.date_hired': 'Date of hire',
  'exportmodal.fields.is_retracted': 'Is retracted',
  'exportmodal.fields.is_manually_added': 'Is manually added',
  'exportmodal.fields.referred_site': 'Source',
  'exportmodal.fields.stage_name': 'Stage name',
  'exportmodal.fields.num_reviews': 'Number of reviews',
  'exportmodal.fields.num_notes': 'Number of notes',
  'exportmodal.select': 'Select all',
  'exportmodal.deselect': 'Deselect all',
  'exportmodal.button.cancel': 'Cancel',
  'exportmodal.button.submit': 'Export',
  'exportmodal.button.close': 'Close',
  'exportmodal.submit.error': 'Unable to export data, please contact 50skills',
  'exportmodal.submitted.title': 'Gathering data',
  'exportmodal.submitted.confirmtext.sent': 'The file is being processed and will be sent to your e-mail address:',
  'exportmodal.submitted.confirmtext.ready': 'when it is ready',
  'exportmodal.submitted.notice': 'Please note this might take a few minutes. If you can\'t find it in your inbox, it might be worth checking your spam folder.',
  'exportjobsmodal.title': 'Export jobs',
  'exportjobsmodal.filter.publisheddate.from': 'Published date • From',
  'exportjobsmodal.filter.publisheddate.to': 'Published date • To',
  'exportjobsmodal.filter.status.header': 'JOB STATUS',
  'exportjobsmodal.filter.status.published': 'Published',
  'exportjobsmodal.filter.status.expired': 'Expired',
  'exportjobsmodal.filter.status.drafts': 'Drafts',
  'exportjobsmodal.filter.status.archived': 'Archived',
  'exportjobsmodal.labels.headers': 'Headers',
  'exportjobsmodal.fields.details': 'JOB DETAILS',
  'exportjobsmodal.fields.id': 'ID',
  'exportjobsmodal.fields.department': 'Department',
  'exportjobsmodal.fields.labels': 'Labels',
  'exportjobsmodal.fields.title': 'Title',
  'exportjobsmodal.fields.location': 'Location',
  'exportjobsmodal.fields.worktype': 'Type',
  'exportjobsmodal.fields.status': 'Status',
  'exportjobsmodal.fields.dates': 'DATES',
  'exportjobsmodal.fields.datecreated': 'Created',
  'exportjobsmodal.fields.datepublished': 'Published',
  'exportjobsmodal.fields.deadline': 'Deadline',
  'exportjobsmodal.fields.applicantstatistics': 'APPLICANT STATISTICS',
  'exportjobsmodal.fields.numapplicants': '# Applicants',
  'exportjobsmodal.fields.hiredapplicants': '# Hired',
  'exportjobsmodal.fields.rejectedapplicants': '# Rejected',
  'exportjobsmodal.fields.retractedapplications': '# Retracted',
  'exportjobsmodal.select': 'Select all',
  'exportjobsmodal.deselect': 'Deselect all',
  'exportjobsmodal.button.cancel': 'Cancel',
  'exportjobsmodal.button.submit': 'Export',
  'exportjobsmodal.button.close': 'Close',
  'exportjobsmodal.submit.error': 'Unable to export data, please contact 50skills',
  'exportjobsmodal.submitted.title': 'Gathering data',
  'exportjobsmodal.submitted.confirmtext.sent': 'The file is being processed and will be sent to your e-mail address:',
  'exportjobsmodal.submitted.confirmtext.ready': 'when it is ready',
  'exportjobsmodal.submitted.notice': 'Please notice this might take a couple of minutes and check your spam folder if you can\'t find it.',
  'integration.submit.error': 'Submission error. Please contact 50skills support.',
  'integration.submit.error.500': 'Something went wrong - please make sure the information entered is correct',
  'integration.submit.save': 'Form saved.',
  'integration.delete.error': 'Delete error. Please contact 50skills support.',
  'integration.preview.title': 'Preview',
  'integration.preview.error': 'Preview error. Please contact 50skills.',
  'integration.validators.ssn': 'Invalid SSN / ID number',
  'integration.validators.number': 'Input should only contain numbers',
  'integration.validators.decimal': 'Input should only contain numbers of the format 0.00',
  'integration.validators.bankNumber': 'Bank number should be 1-4 digits',
  'integration.validators.ledger': 'Ledger should be 2 digits',
  'integration.validators.accountNumber': 'Account number should be 1-6 digits',
  'job.removestage.success': 'Stage was successfully removed.',
  'job.removestage.error': 'Unable to remove stage. Please contact 50skills support.',
  'job.addapplicant.error': 'Error adding applicant. Please check for errors in the form or contact 50skills support.',
  'job.addapplicant.success': 'Applicant created.',
  'job.archive.modal.header': 'Archive job',
  'job.archive.modal.text': 'Are you sure you want to archive {0}?',
  'job.archive.modal.button': 'Archive',
  'job.archive.error': 'Error occured while archiving job. Please contact 50skills support.',
  'job.archive.success': 'Successfully archived job.',
  'job.bulkgrant.error': 'Unable to reject applicant(s). Please contact 50skills.',
  'job.bulkgrant.success': 'Successfully granted {0} user(s) access to {1} applicant(s).',
  'job.bulkreject.error': 'Unable to reject applicant(s). Please contact 50skills.',
  'job.bulkreject.success.marked': 'Successfully rejected {0} applicant(s) and marked them as notified',
  'job.bulkreject.success.notified': 'Successfully rejected {0} applicant(s) and notified them.',
  'job.bulkreject.success': 'Successfully rejected {0} applicant(s).',
  'job.bulkhire.error': 'Unable to hire applicants. Please contact 50skills.',
  'job.bulkhire.success': '{0} applicants hired',
  'job.bulkhire.title': 'Hire applicants',
  'job.bulkhire.confirm': 'Are you sure you want to hire the following applicants?',
  'job.bulkhire.noapplicants': 'There are no active applicants in the selection',
  'job.bulkhire.button.close': 'Close',
  'job.bulkhire.button.cancel': 'Cancel',
  'job.bulkhire.button.submit': 'Confirm',
  'job.bulkmove.success': 'Successfully moved {0} applicant(s) to stage {1}.',
  'job.bulkmove.error': 'Unable to move {0} applicant(s) to stage {1}.',
  'job.bulkmessage.error': 'Unable to send message to applicant(s). Please contact 50skills.',
  'job.bulkmessage.success': 'Successfully messaged {0} applicant(s).',
  'job.bulkmessage.title': 'Message applicant(s)',
  'job.bulkmessage.confirm.single': 'Are you sure you want to message',
  'job.bulkmessage.confirm.multi': 'Are you sure you want to message the following applicants?',
  'job.bulkmessage.button.cancel': 'Cancel',
  'job.bulkmessage.button.submit': 'Send',
  'job.bulkretract.error': 'Unable to retract applicants. Please contact 50skills.',
  'job.bulkretract.success': '{0} applicants retracted',
  'job.bulkactive.error': 'Unable to make applicants active. Please contact 50skills.',
  'job.bulkactive.success': '{0} applicants made active',
  'job.bulkdelete.success': '{0} applicants deleted',
  'job.bulkdelete.error': 'Unable to delete applicants. Please contact 50skills.',
  'job.create.nolang.title': 'No language selected',
  'job.create.nolang.body': 'Press the + button on the left to add a language for this job.',
  'job.create.error': 'Unable to create job. Please contact 50skills support.',
  'job.create.success': 'Successfully saved job as draft.',
  'job.create.field.required': 'This field is required',
  'job.drafts.error': 'Error occurred while moving job. Please contact 50skills support.',
  'job.drafts.success': 'Job successfully moved to drafts.',
  'job.duplicate.error': 'Error while duplicating job. Please contact 50skills support.',
  'job.duplicate.success': 'Job successfully duplicated and saved as a draft.',
  'job.immediateupdate.error': 'Unable to update job detail. Please contact 50skills support.',
  'job.immediateupdate.success': 'Successfully updated job detail',
  'job.renamestage.success': 'Stage renamed to {0}',
  'job.renamestage.error': 'Unable to rename stage to {0}, please contact 50skills support',
  'job.addstage.success': 'Stage added',
  'job.addstage.error': 'Unable to add new stage, please contact 50skills support',
  'job.nodeadline': 'No deadline',
  'job.nolocation': 'No location',
  'job.nodepartment': 'No department',
  'job.notitle': 'No title set',
  'job.datepublished': 'Published: {0}',
  'job.nodatepublished': 'Job not published',
  'job.unknowndatepublished': 'Unknown published date',
  'job.datecreated': 'Created: {0}',
  'job.nodatecreated': 'Unknown created date',
  'job.dateexpired': 'Expired: {0}',
  'job.nodateexpired': 'Unknown deadline',
  'job.datearchived': 'Archived: {0}',
  'job.nodatearchived': 'Unknown archived date',
  'job.datescheduledpublish': 'Scheduled publish: {0}',
  'job.publish.error': 'Error while publishing job. Please contact 50skills support.',
  'job.publish.success': 'Job Successfully published.',
  'job.statistics.all': 'All time',
  'job.statistics.seven': 'Past 7 days',
  'job.statistics.thirty': 'Past 30 days',
  'job.statistics.today': 'Today',
  'job.statistics.from': 'From:',
  'job.tips.notvisible': 'Job is not visible on career page (private)',
  'job.tips.visible': 'Job is visible on career page (public)',
  'job.type.employee': 'Employee',
  'job.type.intern': 'Intern',
  'job.type.not_specified': 'Not specified',
  'job.type.seasonal': 'Seasonal',
  'job.type.temporary': 'Temporary',
  'job.unpublish.error': 'Error while unpublishing job. Please contact 50skills support.',
  'job.unpublish.success': 'Job successfully unpublished.',
  'job.update.description.error': "Unable to update job's description. Please contact 50skills support.",
  'job.update.description.success': "Job's description updated successfully",
  'job.update.followers.error': "Unable to update jobs's access. Please contact 50skills support.",
  'job.update.followers.success': "Access for job updated successfully.",
  'job.update.followers.back': "Back",
  'job.update.followers.cancel': "Cancel",
  'job.update.form.error': "Unable to update job's application form. Please contact 50skills support.",
  'job.update.form.success': "Jobs's application form updated successfully.",
  'job.update.social.error': "Unable to update job's social info. Please contact 50skills support.",
  'job.update.rewards.error': "Unable to update job's rewards. Please contact 50skills support.",
  'job.update.rewards.success': "Job's rewards updated successfully.",
  'job.options.archive': 'Archive',
  'job.options.drafts': 'Move to drafts',
  'job.options.duplicate': 'Duplicate',
  'job.options.edit': 'Edit',
  'job.options.addstage': 'Add stage',
  'job.options.publish': 'Publish',
  'job.options.share': 'Share',
  'job.options.unpublish': 'Unpublish',
  'job.options.delete': 'Delete',
  'job.options.delete.confirmation': 'job and all it\'s applications',
  'job.options.export': 'Export applicants',
  'job.store.delete.error': "Unable to delete {0}. Please contact 50skills support.",
  'job.store.delete.success': "Job successfully deleted.",
  'jobsettings.tab.applicants': 'Applicants',
  'jobsettings.tab.integrations': 'Integrations',
  'jobsettings.tab.statistics': 'Statistics',
  'jobsettings.tab.team': 'Team',
  'navigation.back': 'Back',
  'navigation.careersite': 'Career page',
  'navigation.jobs': 'Jobs',
  'navigation.applicants': 'Applicants',
  'navigation.messages': 'Messages',
  'navigation.onboarding': 'Onboarding',
  'navigation.sharing': 'Sharing',
  'navigation.supportchat': 'Support chat',
  'navigation.expand': 'Fix position',
  'navigation.collapse': 'Unfix position',
  'navigation.companies': 'Companies',
  'navigation.apps': 'Apps',
  'navigation.settings.headers.admin': 'Admin settings',
  'navigation.settings.headers.career': 'Career',
  'navigation.settings.company': 'Company',
  'navigation.settings.career': 'Career site',
  'navigation.settings.careertheme': 'Theme',
  'navigation.settings.departments': 'Departments',
  'navigation.settings.labels': 'Labels',
  'navigation.settings.locations': 'Locations',
  'navigation.settings.templates': 'Templates',
  'navigation.settings.team': 'Team',
  'navigation.settings.jobboards': 'Job boards',
  'navigation.settings.joborder': 'Job order',
  'navigation.settings.integrations': 'Integrations',
  'navigation.settings.worktypes': 'Work types',
  'navigation.profile.headers.profile': 'Profile',
  'navigation.profile.profile': 'Profile',
  'navigation.profile.notifications': 'Notifications',
  'navigation.profile.security': 'Security',
  'navigation.profile.api': 'API',
  'templates.store.newtasklist.name': 'New task list',
  'templates.store.removetasklist.error': 'Failed to remove template. Please contact 50skills support.',
  'templates.store.removetasklist.success': 'Tasklist template successfully removed',
  'user.grant.error': 'Unable to grant access. Please contact 50skills support.',
  'user.grant.success': 'Access has been successfully granted.',
  'user.inactive': 'inactive',
  'user.revoke.error': "Unable to revoke access. Please contact 50skills support.",
  'user.revoke.success': "Access revoked successfully",
  'user.role.superadmin': 'Super-admin',
  'user.role.admin': 'Admin',
  'user.role.limited': 'Limited team member',
  'user.role.recruiter': 'Recruiter',
  'user.role.user': 'Employee',
  'user.profile.invite.resend': 'Resend invite',
  'user.profile.role.label': 'Role',
  'user.profile.departments.label': 'Department/s',
  'user.profile.departments.none': 'No departments',
  'user.profile.departments.fullaccess': 'Full departmental access',
  'user.profile.departments.add': 'Add to department',
  'user.profile.departments.edit': 'Edit access',
  'user.profile.departments.remove': 'Remove from department',
  'usermenu.notifications': 'Notification settings',
  'usermenu.statusPage': 'Status page',
  'usermenu.company.settings': 'Settings',
  'usermenu.jobboards': 'Job boards',
  'usermenu.help': 'Help / Articles',
  'usermenu.profile': 'Profile',
  'usermenu.logout': 'Log out',
  'userstore.delete.error': 'Unable to delete user. Please contact 50skills support.',
  'userstore.delete.success': 'User successfully deleted.',
  'job.header.applicants': 'Applicants',
  'job.header.today': 'Today',
  'job.followermenu.title': 'Hiring team',
  'application.onboardmodal.title': 'Onboard applicant',
  'application.onboardmodal.text': 'Would you like to onboard employee now?',
  'application.onboardmodal.button.later': 'Onboard later',
  'application.onboardmodal.button.go': 'Go to onboarding',
  'rejectmodal.types.reject': 'Reject',
  'rejectmodal.types.rejecthelp': 'Marks the candidate as rejected. No notification is sent',
  'rejectmodal.types.rejectsend': 'Reject and send rejection email',
  'rejectmodal.types.rejectsendhelp': 'Send rejection emails to the selected candidates',
  'rejectmodal.types.rejectmark': 'Mark as rejected and notified',
  'rejectmodal.types.rejectmarkhelp': 'Marks the candidate as rejected and notified. No notification is sent',
  'rejectmodal.title': 'Reject applicant(s)',
  'rejectmodal.confirm.single': 'Are you sure you want to reject',
  'rejectmodal.confirm.multi': 'Are you sure you want to reject the following candidates?',
  'rejectmodal.confirmed.reject': 'The following candidates will be marked as rejected:',
  'rejectmodal.confirmed.rejectsend': 'The following candidates will receive a rejection email:',
  'rejectmodal.confirmed.rejectmark': 'The following candidates will be rejected and marked as notified:',
  'rejectmodal.excluded': 'The following candidates will not be included in this action:',
  'rejectmodal.already.notified': '(already rejected and notified)',
  'rejectmodal.already.rejected': '(already rejected)',
  'rejectmodal.method.title': 'Rejection method',
  'rejectmodal.method.drop.title': 'Select rejection method',
  'rejectmodal.button.cancel': 'Cancel',
  'rejectmodal.button.submit': 'Reject',
  'assignmodal.button.cancel': 'Cancel',
  'assignmodal.button.submit': 'Assign',
  'assignmodal.header': 'Assign applicant',
  'assignmodal.description': 'Assign a user from your team to this applicant',
  'assignmodal.select.emptystate': 'Select user',
  'assignmodal.select.label': 'Assignee',
  'rejectform.label.from': 'From',
  'rejectform.label.message': 'Message',
  'rejectform.label.templateselect': 'Name of template',
  'rejectform.template.drop.title': 'Select template',
  'rejectform.error.message': 'Please add some body text to the e-mail.',
  'editor.placeholder.title': 'Placeholder',
  'editor.placeholder.name': 'Applicant name',
  'editor.placeholder.job_title':'Job title',
  'editor.placeholder.sender_name': 'Sender name',
  'editor.placeholder.first_name': 'Applicant first name',
  'editor.placeholder.last_name': 'Applicant last name',
  'editor.placeholder.ob_url': 'URL to onboarding integration',
  'editor.placeholder.company_name': 'Company name',
  'sharejob.header': 'Share job',
  'sharejob.copy.header.direct': 'Direct link',
  'sharejob.copy.header.referral': 'Referral link',
  'sharejob.selected.tab.direct': 'Direct link',
  'sharejob.selected.tab.referral': 'Referral link',
  'sharejob.tabs.label': 'Direct or Referral selection',
  'copy.button.text': 'Copy',
  'copy.button.copied': 'Copied',
  'sharejob.maintext': 'This is a permanent link that references your 50skills Job ad. It does not change when you change the job ad title. This is the recommended way to share your form.',
  'sharejob.share.media': 'Share via',
  'sharejob.share.media.with': 'Share via',
  'sharejob.share.facebook': 'Facebook',
  'sharejob.share.linkedin': 'Linkedin',
  'sharejob.share.email': 'Email',
  'sharejob.rewards.header': 'Rewards for hired applicant',
  'sharejob.modal.header': 'Share job',
  'sharejob.modal.close': 'Close',
  'userlist.header.name': 'Name',
  'userlist.header.email': 'Email',
  'userlist.header.role': 'Role',
  'userlist.header.department': 'Department',
  'userlist.header.access': 'Access',
  'userlist.header.status': 'Status',
  'userlist.header.options': 'options',
  'application.options.email': 'Send email',
  'application.options.access': 'Grant access',
  'application.options.move': 'Move to job',
  'application.options.copy': 'Copy to job',
  'application.options.edit': 'Edit',
  'application.options.delete': 'Delete',
  'application.options.reject': 'Reject',
  'application.options.unreject': 'Unreject',
  'application.options.hire': 'Hire',
  'application.options.unhire': 'Unhire',
  'application.options.retract': 'Mark as retracted',
  'application.options.unretract': 'Unmark as retracted',
  'application.options.onboard': 'Onboard',
  'application.edit.error': 'Error editing applicant. Please check for errors in the form or contact 50skills support.',
  'application.edit.success': 'Application successfully changed.',
  'application.tip.assign': 'Assign applicant to a member of your team',
  'modals.confirm.title': 'Confirm',
  'modals.confirm.warning': 'This action can not be undone!',
  'modals.confirm.please': 'Please confirm',
  'modals.confirm.understanding': 'I understand',
  'modals.confirm.button.close': 'Close',
  'modals.confirm.button.cancel': 'Cancel',
  'modals.confirm.button.submit': 'Confirm',
  'modals.removeconfirm.title': 'Confirm deletion',
  'modals.removeconfirm.attachment.confirm': 'Are you sure you wish to delete this attachment?',
  'modals.removeconfirm.note.confirm': 'Are you sure you wish to delete this note?',
  'modals.removeconfirm.tasklist.confirm': 'Are you sure you wish to delete this tasklist?',
  'modals.removeconfirm.user.confirm': 'Are you sure you wish to delete this user?',
  'modals.removeconfirm.contract.header': 'Delete contract',
  'modals.removeconfirm.contract.main': 'Are you sure you wish to delete this contract?',
  'modals.removeconfirm.contract.button': 'Delete contract',
  'modals.removeconfirm.warning': 'Warning, this action can not be undone!',
  'modals.removeconfirm.button.cancel': 'Cancel',
  'modals.removeconfirm.button.submit': 'Delete',
  'modals.removeauthenticator.header': 'Remove authentication',
  'modals.removeauthenticator.subheader': 'For your security, please enter you password',
  'modals.removeauthenticator.label.password': 'Password',
  'modals.removeauthenticator.button.cancel': 'Cancel',
  'modals.removeauthenticator.button.submit': 'Remove',
  'modals.addauthenticator.header': 'Enable two step verification via authenticator app',
  'modals.addauthenticator.subheader': 'For your security, please enter you password',
  'modals.addauthenticator.password.label': 'Password',
  'modals.addauthenticator.password.error': 'Incorrect password',
  'modals.addauthenticator.qrcode.helptext': '1. Scan the QR code',
  'modals.addauthenticator.code.helptext': '2. Enter the 6 digit code below',
  'modals.addauthenticator.code.label': 'Code',
  'modals.addauthenticator.code.required': 'This field is required',
  'modals.addauthenticator.code.error': 'Code does not match',
  'modals.addauthenticator.header.success': 'Two step authentication enabled',
  'modals.addauthenticator.subheader.success': 'Congratulations, you have enabled two-step verification. From now on when you sign in to 50skills you will need to enter your password and secure code from your phone.',
  'modals.addauthenticator.button.cancel': 'Cancel',
  'modals.addauthenticator.button.submit': 'Continue',
  'modals.addsmsauthenticator.header': 'Enable two step verification via SMS',
  'modals.addsmsauthenticator.subheader': 'For your security, please enter you password',
  'modals.addsmsauthenticator.password.label': 'Password',
  'modals.addsmsauthenticator.password.error': 'Incorrect password',
  'modals.addsmsauthenticator.step2.helptext': '50skills will send a code to your phone whenever you use sign in.',
  'modals.addsmsauthenticator.countrycode.label': 'Country code',
  'modals.addsmsauthenticator.phonenumber.label': 'Phone number',
  'modals.addsmsauthenticator.phonenumber.required': 'This field is required',
  'modals.addsmsauthenticator.phonenumber.error': 'Unable to send SMS, is the number correct?',
  'modals.addsmsauthenticator.step3.helptext': 'We sent a 6-digit code in a text message to the phone number {0}',
  'modals.addsmsauthenticator.label.code': 'Code',
  'modals.addsmsauthenticator.header.success': 'Two step authentication enabled',
  'modals.addsmsauthenticator.subheader.success': 'Congratulations, you have enabled two-step verification. From now on when you sign in to 50skills you will need to enter your password and secure code from your phone.',
  'modals.addsmsauthenticator.button.cancel': 'Cancel',
  'modals.addsmsauthenticator.button.back': 'Back',
  'modals.addsmsauthenticator.button.submit': 'Continue',
  'modals.notifytwofactor.header': 'Enable 2FA',
  'modals.notifytwofactor.text': 'Please be adviced, two factor authentication is enabled for your company, you will need a verification app such as Google authenticator. You can enable it on this page.',
  'modals.notifytwofactor.button.close': 'Close',
  'modals.sendinvite.header': 'Send invite',
  'modals.sendinvite.main': 'Are you sure you want to send an invite to {0}? They will receive an email that gives them access to 50skills.',
  'modals.sendinvite.button': 'Send invite',
  'modals.deleteuserapp.header': 'Remove API key',
  'modals.deleteuserapp.content': 'Are you sure you want to remove this API key? Anyone using these tokens will not be able to do so from now on.',
  'modals.deleteuserapp.undone':'This can not be undone.',
  'modals.adddepartment.header': 'Add department',
  'modals.adddepartment.label': 'Department name • {0}',
  'modals.adddepartment.helptext': 'Displayed on your job posts and career page',
  'modals.adddepartment.externalid.label': 'External ID',
  'modals.adddepartment.externalid.helptext': 'Optional external ID',
  'modals.adddepartment.cancel': 'Cancel',
  'modals.adddepartment.save': 'Save',
  'modals.adddepartment.success': 'Department added',
  'modals.editdepartment.header': 'Edit department',
  'modals.editdepartment.success': 'Department saved',
  'modals.deletedepartment.header': 'Delete department',
  'modals.deletedepartment.content': 'Are you sure you want to delete this department? This action can not be undone and all user relations with this department will be deleted.',
  'modals.deletedepartment.cancel': 'Cancel',
  'modals.deletedepartment.save': 'Delete',
  'modals.deletedepartment.success': 'Department deleted',
  'modals.adddepartmentuser.header': 'Add to department',
  'modals.adddepartmentuser.subheader': 'Add a user to selected department',
  'modals.adddepartmentuser.department.label': 'Department',
  'modals.adddepartmentuser.department.nooptions': 'No departments available',
  'modals.adddepartmentuser.users.label': 'Users',
  'modals.adddepartmentuser.user.nooptions': 'No users available',
  'modals.adddepartmentuser.fullaccess.label': 'Full departmental access',
  'modals.adddepartmentuser.fullaccess.tooltip': 'Access to all jobs and applications within selected department',
  'modals.adddepartmentuser.fullaccess.description': 'Please note, only super-admins or admins with full departmental access are able to grant or remove full departmental access',
  'modals.adddepartmentuser.fullaccess.yousure': 'Are you sure you want to grant this user full departmental access? They will have full access to all jobs and applicants within the selected department',
  'modals.adddepartmentusers.fullaccess.yousure': 'Are you sure you want to grant these users full departmental access? They will have full access to all jobs and applicants within the selected department',
  'modals.adddepartmentuser.cancel': 'Cancel',
  'modals.adddepartmentuser.save': 'Add to department',
  'modals.adddepartmentuser.success': 'Department user added',
  'modals.editdepartmentuser.header': 'Edit department access',
  'modals.editdepartmentuser.save': 'Save',
  'modals.editdepartmentuser.success': 'Department access saved',
  'modals.deletedepartmentuser.header': 'Please confirm',
  'modals.deletedepartmentuser.areyousure.1': 'Are you sure you want to remove',
  'modals.deletedepartmentuser.areyousure.2': 'from department',
  'modals.deletedepartmentuser.fullaccessdescription': 'If they have department access, they will lose access to all jobs and applicants within the selected department',
  'modals.deletedepartmentuser.cancel': 'Cancel',
  'modals.deletedepartmentuser.save': 'Confirm and remove',
  'modals.deletedepartmentuser.success': 'User removed from department',
  'modals.deleteuserapp.cancel': 'Cancel',
  'modals.deleteuserapp.save': 'Remove',
  'modals.deleteuserapp.success': 'User app deleted',
  'modals.adduserapp.header': 'Add user app',
  'modals.adduserapp.label': 'User app title',
  'modals.adduserapp.helptext': 'Write a unique name this user app. It is only used so you can differentiate between user apps.',
  'modals.adduserapp.cancel': 'Cancel',
  'modals.adduserapp.save': 'Save',
  'modals.adduserapp.success': 'User app created',
  'modals.userappcredentials.header': 'User app credentials',
  'modals.userappcredentials.helptext': 'Copy the credentials below and save them in a secure location. You will need them to authenticate with the external API.',
  'modals.userappcredentials.clientid.label': 'Client ID',
  'modals.userappcredentials.secret.helptext': 'Client secret is only displayed once',
  'modals.userappcredentials.clientsecret.label': 'Client Secret',
  'modals.userappcredentials.close': 'Close',
  'modals.addlocation.header': 'Add location',
  'modals.addlocation.success': 'Location added',
  'modals.editlocation.header': 'Edit location',
  'modals.editlocation.success': 'Location edited',
  'modals.location.label': 'Location name • {0}',
  'modals.location.helptext': 'Displayed on your job posts and career page',
  'modals.location.externalid.label': 'External ID',
  'modals.location.externalid.helptext': 'Optional external ID',
  'modals.location.address.label': 'Address',
  'modals.location.address.placeholder': 'Address',
  'modals.location.address.initialtext': 'Enter an address',
  'modals.location.address.nomatchingtext': 'No address found matching your search',
  'modals.location.isactive.label': 'Active',
  'modals.deletelocation.header': 'Delete location',
  'modals.deletelocation.text': 'Are you sure you want to delete this location?',
  'modals.deletelocation.save': 'Delete location',
  'modals.deletelocation.success': 'Location deleted',
  'job.create.crumb.new': 'New job post',
  'job.create.crumb.editing': 'Edit job post',
  'job.create.step.1': 'Job details',
  'job.create.step.1.mobile': '1',
  'job.create.step.2': 'Application form',
  'job.create.step.2.mobile': '2',
  'job.create.step.3': 'Social & Rewards',
  'job.create.step.3.mobile': '3',
  'job.create.step.4': 'Access',
  'job.create.step.4.mobile': '4',
  'job.create.step.5': 'Preview and Publish',
  'job.create.step.5.live': 'Preview',
  'job.create.step.5.mobile': '5',
  'job.create.form.header': 'Application form',
  'job.create.form.show': 'Show',
  'job.create.form.required': 'Required',
  'job.create.form.social.header': 'Social Profiles',
  'job.create.form.questions.header': 'Questions',
  'job.create.form.button.addquestion': 'Add question',
  'job.create.form.label.coverletter': 'Cover Letter',
  'job.create.form.label.cv': 'CV / Resume',
  'job.create.form.label.name': 'Name',
  'job.create.form.label.email': 'Email',
  'job.create.form.label.phone': 'Phone',
  'job.create.form.label.ssn': 'SSN / ID number',
  'job.create.form.label.language': 'Application language',
  'job.create.form.questions.type.short': 'Short answer',
  'job.create.form.questions.type.para': 'Paragraph',
  'job.create.form.questions.type.single': 'Single-select',
  'job.create.form.questions.type.multi': 'Multi-select',
  'job.create.form.questions.type.attachment': 'Attachment',
  'job.create.form.questions.title.edit': 'Edit question',
  'job.create.form.questions.title': 'Add question',
  'job.create.form.questions.type.label': 'Question type',
  'job.create.form.questions.qlabel': 'Question',
  'job.create.form.questions.qerror': 'What would you like to know?',
  'job.create.form.questions.qopts': 'Options',
  'job.create.form.questions.multipleattachments.label': 'Allow multiple file uploads',
  'job.create.form.questions.multipleattachments.yes': 'Yes',
  'job.create.form.questions.multipleattachments.no': 'No',
  'job.create.form.questions.button.cancel': 'Cancel',
  'job.create.form.questions.button.submit': 'Add Question',
  'job.create.form.questions.button.submitedit': 'Update Question',
  'job.create.form.questions.option.edit': 'Edit',
  'job.create.form.questions.option.moveup': 'Move Up',
  'job.create.form.questions.option.movedn': 'Move Down',
  'job.create.form.questions.option.delete': 'Delete',
  'job.create.form.questions.seeoptions': 'Click to see options',
  'job.create.form.questions.error': 'The question form contains errors.',
  'job.create.form.options.tip.remove': 'Remove this option',
  'job.create.form.options.tip.add': 'Add another option below this one',
  'job.create.form.options.empty': 'Option value should not be empty',
  'job.create.form.require': 'Require',
  'job.create.form.optional': 'Optional',
  'job.create.form.off': 'Off',
  'job.create.header': 'Create job',
  'job.create.header.edit': 'Edit job',
  'job.create.description.header': 'Job Description',
  'job.create.description.hyper.link.save': 'Save',
  'job.create.description.hyper.link.addLink': 'Add link',
  'job.create.description.hyper.link.linkToolTip': 'Select what you want to turn into a hyperlink',
  'job.create.description.hyper.link.label': 'Link',
  'job.create.button.cancel': 'Cancel',
  'job.create.button.save': 'Save',
  'job.create.button.back': 'Back',
  'job.create.button.savedraft': 'Save Draft',
  'job.create.button.cont': 'Continue',
  'job.create.button.savecont': 'Save & Continue',
  'job.create.label.title': 'Job title',
  'job.create.label.location': 'Location',
  'job.create.label.location.add': 'Add location',
  'job.create.label.location.add.permission': 'Contact a super-admin to add more locations',
  'job.create.label.location.missingtranslation': 'Missing location translation',
  'job.create.label.type': 'Job Type',
  'job.create.label.status': 'Job Status',
  'job.create.label.deadline': 'Application deadline (optional)',
  'job.create.label.short': 'Short description',
  'job.create.label.shortinfo': 'Appears on career overview page\n{0} characters max',
  'job.create.label.visibility': 'Visibility',
  'job.create.label.department': 'Department',
  'job.create.label.department.title': 'Select department',
  'job.create.label.department.missingtranslation': 'Missing translation for department',
  'job.create.short.error': 'Short job description is required',
  'job.create.save.language.error': 'Unable to save job. This job is currently published and {0} is enabled but contains errors. Please fix the errors or disable the language for this job.',
  'job.create.location.error': 'Location is required',
  'job.create.title.error': 'Job title is required',
  'job.create.label.long': 'About the job',
  'job.create.preview.button.close': 'Close',
  'job.create.preview.button.edit': 'Edit job',
  'job.create.preview.button.publish': 'Publish job',
  'job.create.preview.text': 'Live preview',
  'job.create.preview.openings': 'current openings',
  'job.create.preview.apply': 'apply now',
  'job.create.linkedField.tip': 'Linked between languages',
  'job.create.publish.language.error': 'Unable to publish job. {0} is enabled but is incomplete.',
  'job.create.publish.no_enabled_language': 'Unable to publish job. There are no enabled languages for it.',

  'job.create.languages.missing.title': 'Title',
  'job.create.languages.missing.description': 'Job description',
  'job.create.languages.missing.short': 'Short description',
  'job.create.languages.missing.location': 'Location',
  'job.create.languages.missing.form': 'Question form',
  'job.create.languages.header': 'Languages',
  'job.create.languages.add': 'Add language',
  'job.create.languages.formIncomplete': 'Form incomplete',
  'job.create.languages.descIncomplete': 'Description incomplete',
  'job.create.languages.menu.publish': 'Enable language',
  'job.create.languages.menu.unpublish': 'Disable language',
  'job.create.languages.menu.delete': 'Remove language',
  'job.create.languages.publish.incomplete': 'Could not enable {0} as the language data is incomplete. Please add the missing data and try enabling again. Incomplete: {1}',
  'job.create.languages.publish.error': 'Could not enable job. Please contact 50skills support.',
  'job.create.languages.publish.success': 'Job successfully enabled.',
  'job.create.languages.unpublish.onlyone': 'Cannot disable job. The job is published and only has this language set.',
  'job.create.languages.unpublish.error': 'Could not disable job. Please contact 50skills support.',
  'job.create.languages.unpublish.success': 'Job successfully disabled.',
  'job.create.languages.delete.error': 'Unable to remove language.',
  'job.create.languages.delete.success': 'Language successfully removed.',
  'job.create.missing.question': 'No question text specified',
  'job.create.languages.enabled': 'This language is enabled',
  'job.create.languages.enabled.live': 'This language is currently live',
  'job.create.languages.disabled': 'This language is disabled',

  'job.types.employee': 'Employee',
  'job.types.temporary': 'Temporary / Contract',
  'job.types.intern': 'Intern',
  'job.types.seasonal': 'Seasonal',
  'job.types.not_specified': 'Not specified',
  'job.status.full_time': 'Full time',
  'job.status.part_time': 'Part time',
  'job.status.per_diem': 'Per diem',
  'job.status.not_specified': 'Not specified',
  'job.visibility.public': 'Shown on career page (public)',
  'job.visibility.private': 'Only via direct link (private)',

  'job.create.publish.modal.title': 'Job successfully published',
  'job.create.publish.modal.jobboard.button': 'Job boards',
  'job.create.publish.modal.tagline': 'Now share it with the world!',
  'job.create.publish.modal.jobboard.tagline': 'Drive traffic to your posts by posting directly to public job boards',
  'job.create.publish.modal.publishjob.title': 'Post to job boards',
  'job.create.publish.modal.direct.title': 'Direct (for job boards etc.)',
  'job.create.publish.modal.direct.title.single': 'Direct',
  'job.create.publish.modal.en': 'English job description',
  'job.create.publish.modal.is': 'Icelandic job description',
  'job.create.publish.modal.direct.head': 'Direct link',
  'job.create.publish.modal.direct.sub': 'for job boards etc.',
  'job.create.publish.modal.refer.title': 'Referral',
  'job.create.publish.modal.refer.head': 'Unique referral link',
  'job.create.publish.modal.button.close': 'Close',

  'job.create.social.title': 'Social sharing',
  'job.create.social.p1': 'When this ad is shared on social media, the default social sharing image is used. Add an image here if you wish to use a custom image for this job.',
  'job.create.social.p2': 'For best results, use a landscape image: 1200 by 630 pixels. We will shrink the width to 1200 if the image is wider.',
  'job.create.social.add': 'New image',
  'job.create.social.label.title': 'Sharing title',
  'job.create.social.label.description': 'Sharing description',

  'job.create.rewards.title': 'Rewards',
  'job.create.rewards.tagline': 'Select bonuses for your employees if their job share or sourcing leads to a hire.',
  'job.create.rewards.toggle': 'Sourcing bonus',
  'job.create.rewards.label.title': 'Title',
  'job.create.rewards.label.reward': 'Amount or Reward',
  'job.create.access.team.header': 'Team',
  'job.create.access.team.search.placeholder': 'Search name, email or role',
  'job.create.access.team.search.enterprise.placeholder': 'Search name, email, role or department',
  'job.create.access.team.add.hiringteam.tooltip': 'Add to hiring team',
  'job.create.access.team.add.limitedaccess.tooltip': 'Add to limited access',
  'job.create.access.team.search.empty': 'No team member found.',
  'job.create.access.team.empty': 'All team members added.',
  'job.create.access.hiringteam.header': 'Hiring team',
  'job.create.access.hiringteam.header.tooltip': 'Full access to this job and all applications within it',
  'job.create.access.hiringteam.remove.tooltip': 'Remove',
  'job.create.access.limitedaccess.header': 'Limited access',
  'job.create.access.limitedaccess.header.tooltip': 'Limited users can only view and access applications they have been manually added to',
  'job.create.access.limitedaccess.subtitle': 'Access: {0} Applicant(s)',
  'job.create.access.limitedaccess.remove.tooltip': 'Remove',
  'job.create.access.limitedaccess.empty': 'No users with limited access on this job.',

  'multiselect.nooptions': 'No more options',

  'jobs.nojobs.published': 'No published jobs',
  'jobs.nojobs.expired': 'No expired jobs',
  'jobs.nojobs.drafts': 'No drafts',
  'jobs.nojobs.archived': 'No archived jobs',
  'jobs.alljobs.published': 'You do not have access to any published jobs',
  'jobs.alljobs.expired': 'You do not have access to any expired jobs',
  'jobs.alljobs.drafts': 'You do not have access to any draft jobs',
  'jobs.alljobs.archived': 'You do not have access to any archived jobs',
  'jobs.tabs.mobile.display': 'Show: {0}',
  'jobs.search.placeholder': 'Search...',
  'jobs.search.tip': 'Search for job',

  'messages.list.header': 'Messages',
  'messages.header.search.placeholder': 'Search...',
  'messages.list.columns.applicationname': 'Applicant name',
  'messages.list.columns.applicationemail': 'Applicant email',
  'messages.list.columns.jobtitle': 'Job',
  'messages.list.columns.jobstagename': 'Stage',
  'messages.list.columns.applicationstatus': 'Status',
  'messages.list.columns.message': 'Message',
  'messages.list.columns.date': 'Received',
  'messages.list.columns.assignedto': 'Assigned to',
  'messages.list.columns.nummessages': '# Messages',
  'messages.list.view': 'View messages',
  'messages.list.nomessages.header': 'No messages',
  'messages.list.nomessages.content': 'When an applicant you have access to sends a new message, it will appear here',
  'messages.list.status.active': 'Active',
  'messages.list.status.hired': 'Hired',
  'messages.list.status.rejected': 'Rejected',
  'messages.list.status.retracted': 'Retracted',
  'messages.list.actions.markread': 'Mark as read',
  'messages.list.actions.markread.success': 'Message marked as read',
  'messages.list.actions.markread.error': 'Unable to mark message as read',
  'messages.list.actions.markunread': 'Mark as unread',
  'messages.list.actions.markunread.success': 'Message marked as unread',
  'messages.list.actions.markunread.error': 'Unable to mark message as unread',
  'messages.list.actions.assign': 'Assign applicant',
  'messages.filters.showing': 'Showing {0} / {1} messages',
  'messages.filters.quick.new.title': 'Unread messages',
  'messages.filters.quick.assignedtome.title': 'Applicant assigned to me',
  'messages.filters.quick.assignedtonoone.title': 'Applicant unassigned',
  'messages.filters.date': 'Received date',
  'messages.filters.date.title': 'Received date',
  'messages.filters.name': 'Applicant name',
  'messages.filters.name.title': 'Applicant name',
  'messages.filters.email': 'Applicant email',
  'messages.filters.email.title': 'Applicant email',
  'messages.filters.job': 'Job',
  'messages.filters.job.title': 'Job',
  'messages.filters.job.state': 'Status: {0}',
  'messages.filters.job.showing': 'Showing first 8',
  'messages.filters.text': 'Message',
  'messages.filters.text.title': 'Message',
  'messages.filters.assigned.title': 'Assigned to',
  'messages.filters.assigned.me': 'Me',
  'messages.filters.assigned.none': 'No one',
  'messages.filters.assigned.anyone': 'Anyone',
  'messages.filters.label': 'Labels',
  'messages.filters.label.title': 'Labels',
  'messages.filters.label.new': 'Unread',

  'forgotpw.reseterror': 'Please supply a valid email',
  'setpw.error.notmatching': 'Passwords do not match',
  'setpw.agree': 'I agree to the',
  'setpw.terms': 'terms of service',
  'setpw.and': 'and',
  'setpw.privacypolicy': 'privacy policy',
  'setpw.label.password': 'Password',
  'setpw.label.confirm': 'Confirm password',
  'setpw.twofactor.step1.label': 'Set password',
  'setpw.twofactor.step1.heading': 'Welcome to 50skills',
  'setpw.twofactor.step1.instruction': 'Please be adviced, two factor authentication is enabled for your company, you will need a verification app such as Google authenticator to be able to complete signup.',
  'setpw.twofactor.step1.hasauthenticatorapp': 'I have an authenticator app installed',
  'setpw.twofactor.step1.submit': 'Continue',
  'setpw.twofactor.step2.label': 'Enable 2FA',
  'setpw.twofactor.step2.heading': 'Please choose your password',
  'setpw.twofactor.step2.password.nomatch': 'Passwords do not match',
  'setpw.twofactor.step2.password.required': 'This field is required',
  'setpw.twofactor.step2.submit': 'Set password',
  'setpw.twofactor.step3.heading': 'Enable 2FA',
  'setpw.twofactor.step3.qrcode.helptext': '1. Scan the QR code',
  'setpw.twofactor.step3.code.helptext': '2. Enter the 6 digit code below',
  'setpw.twofactor.step3.code.label': 'Code',
  'setpw.twofactor.step3.countrycode.label': 'Country code',
  'setpw.twofactor.step3.phone.label': 'Phone number (optional)',
  'setpw.twofactor.step3.phone.helptext': '3. You can set your phone number as a backup',
  'setpw.twofactor.step3.submit': 'Authenticate',
  'setpw.twofactor.step4.heading': 'Password successfully set and you are verified',
  'setpw.twofactor.step4.subheading': 'You are all set',
  'setpw.twofactor.step4.submit': 'Go to 50skills',
  'pwsuccess.set.heading': 'Password successfully set',
  'pwsuccess.reset.heading': 'Password successfully reset',
  'pwsuccess.instruction': 'You are all set to log in with your email and password',
  'pwsuccess.signin':'Sign in',
  'company.settings.career.theme.header': 'Theme',
  'company.settings.career.theme.description': 'Manage your company\'s career site logo and banner',
  'company.settings.career.theme.logo.title': 'Company logo',
  'company.settings.career.theme.logo.description': 'Add your company logo that should be displayed in the header.\nFor best results, use an image that is at least 2x larger than your intended size.',
  'company.settings.career.theme.banner.title': 'Career site banner image',
  'company.settings.career.theme.banner.description': 'Add the career site bannar image you want displayed in the header of your career site and job application forms.\n\nRecommended size is 2880 x 480 pixels',
  'company.settings.career.theme.logosize.title': 'Logo display size',
  'company.settings.career.theme.logosize.description': 'We recommend a display size between 24 and 40 pixels depending on the dimensions of your logo',
  'company.settings.career.theme.logosize.label': 'Display size',
  'company.settings.company.header': 'Company',
  'company.settings.company.career.header': 'Career site',
  'company.settings.jobboards.header': 'Job boards',
  'company.settings.jobboards.subtitle':
    'Connect to job boards to post your job ads directly from 50skills.',
  'company.settings.departments.header': 'Departments',
  'company.settings.departments.columns.title': 'Title',
  'company.settings.departments.columns.externalid': 'External ID',
  'company.settings.departments.columns.externalid.none': 'No external ID',
  'company.settings.departments.columns.numjobs': '# Jobs',
  'company.settings.departments.columns.numusers': '# Users',
  'company.settings.departments.add': 'Add department',
  'company.settings.departments.add.disabled': 'Only Super-admins can add departments',
  'company.settings.departments.actions.addusers': 'Add users',
  'company.settings.departments.actions.addusers.disabled': 'You don\'t have access to this department',
  'company.settings.departments.actions.edit': 'Edit',
  'company.settings.departments.actions.delete': 'Delete',
  'company.settings.departments.actions.delete.disabled': 'Department has active jobs',
  'company.settings.departments.nodepartment': 'No department',
  'company.settings.departments.nodepartments.header': 'No departments',
  'company.settings.departments.nodepartments.content': 'You do not have any departments. Add departments to categorize and define access to job postings.',
  'company.settings.locations.header': 'Locations',
  'company.settings.locations.search.placeholder': 'Search',
  'company.settings.locations.columns.title': 'Title',
  'company.settings.locations.columns.title.notranslation': 'Missing translation',
  'company.settings.locations.columns.address': 'Address',
  'company.settings.locations.columns.zipcode': 'ZIP',
  'company.settings.locations.columns.city': 'City',
  'company.settings.locations.columns.state': 'State',
  'company.settings.locations.columns.country': 'Country',
  'company.settings.locations.columns.externalid': 'External ID',
  'company.settings.locations.columns.externalid.none': 'No external ID',
  'company.settings.locations.columns.numjobs': '# Jobs',
  'company.settings.locations.add': 'Add location',
  'company.settings.locations.add.disabled': 'Only Super-admins can add locations',
  'company.settings.locations.actions.edit': 'Edit',
  'company.settings.locations.actions.delete': 'Delete',
  'company.settings.locations.actions.delete.disabled': 'Location has active jobs',
  'company.settings.locations.actions.deactivate': 'Deactivate',
  'company.settings.locations.actions.activate': 'Activate',
  'company.settings.locations.nolocations.header': 'No locations',
  'company.settings.locations.nolocations.content': 'You do not have any locations. Add locations to categorize and define access to job postings.',
  'company.settings.locations.tabs.active': 'Active',
  'company.settings.locations.tabs.inactive': 'Inactive',
  'company.settings.locations.locationconflict.header': 'Location name already in use',
  'company.settings.locations.locationconflict.samename': 'Another active location has the same name in this language:',
  'company.settings.locations.locationconflict.samename.instruction': 'To activate this location, rename it or deactivate the existing one.',
  'company.settings.locations.locationconflict.close': 'Close',
  'company.settings.apps.noapps': 'No apps. Contact us if you need some integrations',
  'company.settings.apps.slack': 'Slack',
  'company.settings.apps.getaccept': 'GetAccept',
  'company.settings.apps.onboardingform': 'Onboarding Form',
  'company.settings.apps.kjarni': 'Kjarni',
  'company.settings.apps.asana': 'Asana',
  'company.settings.apps.hrmonitor': 'HR Monitor',
  'company.settings.apps.relesys': 'Relesys',
  'company.settings.apps.hireflix': 'Hireflix',
  'company.settings.apps.h3core': 'H3Core',
  'company.settings.apps.timon': 'Tímon',
  'company.settings.apps.mytimeplan': 'MyTimePlan',
  'company.settings.apps.dokobit': 'Dokobit',
  'company.settings.apps.onecrm': 'OneCRM',
  'company.settings.apps.admanager': 'AD Manager',
  'company.settings.apps.signet': 'Signet',
  'company.settings.apps.taktikal': 'Taktikal',
  'company.settings.root.details': 'Details',
  'company.settings.root.messagessendername.title': 'Messages sender name',
  'company.settings.root.messagessendername.description': 'The default email sender name for all messages sent from the 50skills system.',
  'company.settings.root.messagessendername.placeholder': 'HR Company name',
  'company.settings.root.messagessendername.label': 'Sender name',
  'company.settings.root.messagessendername.error': 'Sender name cannot be empty',
  'company.settings.root.messagessendername.updateSuccess': 'Sender name successfully updated.',
  'company.settings.root.messagessendername.updateError': 'Error while updating sender name.',
  'company.settings.root.ga.title': 'Google Analytics',
  'company.settings.root.ga.extendedtitle': 'Google analytics tracking id',
  'company.settings.root.ga.description': 'Add your Google Analytics tracking code to your career site.',
  'company.settings.root.ga.placeholder': 'None',
  'company.settings.root.ga.label': 'Tracking ID',
  'company.settings.root.ga.edit': 'Edit',
  'company.settings.root.ga.remove': 'Remove tracking code',
  'company.settings.root.ga.updateSuccess': 'Company Google Analytics tracking code successfully updated.',
  'company.settings.root.ga.updateError': 'Error while updating Google Analytics tracking code.',
  'company.settings.root.privacy.title': 'Privacy policy URL',
  'company.settings.root.privacy.description': 'If you have a privacy policy, add the url here and it will be displayed at the bottom of the career site application form.',
  'company.settings.root.privacy.placeholder': 'None',
  'company.settings.root.privacy.label': 'URL',
  'company.settings.root.privacy.updateSuccess': 'Company privacy policy URL successfully updated.',
  'company.settings.root.privacy.updateError': 'Error while updating company privary policy URL.',
  'company.settings.root.selectlangs': 'Select languages',
  'company.settings.root.heading': 'Company Profile',
  'company.settings.root.label.name': 'Company name',
  'company.settings.root.label.url': 'Company URL',
  'company.settings.root.label.deadline': 'Job requires expiration dates',
  'company.settings.root.label.langs': 'Career page languages',
  'company.settings.root.label.ssnvalidation': 'Enable SSN validation for job application (Icelandic SSN only)',
  'company.settings.root.button.cancel': 'Cancel',
  'company.settings.root.button.submit': 'Save',
  'company.settings.root.updateSuccess': 'Company details successfully updated.',
  'company.settings.root.updateError': 'Error while updating company details.',
  'company.settings.root.companyname.required': 'Company name is required',
  'company.settings.root.url.error': 'A valid URL is required',
  'company.settings.root.deadline.title': 'Deadlines',
  'company.settings.root.deadline.description': 'When enabled, jobs in your company can not be created without a deadline',
  'company.settings.root.deadline.required': 'Deadlines required',
  'company.settings.root.deadline.enabled': 'Enabled',
  'company.settings.root.deadline.disabled': 'Disabled',
  'company.settings.career.header': 'Career site',
  'company.settings.career.languages': 'Languages',
  'company.settings.career.description': 'Default social sharing details',
  'company.settings.career.description.helptext': 'Default title and description text that appears when you share a job on social platforms',
  'company.settings.career.languages.helptext.p2': 'Your career site will be displayed in the enabled languages and jobs if translations are added (per job)',
  'company.settings.career.image': 'Default social sharing image',
  'company.settings.career.image.helptext': 'When your career page or job is posted on social media this image is used, unless there is a custom image added to the job.\n\nFor best results, use a landscape image: 1200 by 630 pixels.  We will shrink the width to 1200 if the image is wider. Max size 5mb',
  'company.settings.career.update.description.error': 'Error updating description',
  'company.settings.career.update.description.success': 'Description successfully updated',
  'company.settings.career.update.logoheight.error': 'Error updating logo height',
  'company.settings.career.update.logoheight.success': 'Logo height successfully updated',
  'company.settings.career.social.title.label': 'Sharing title',
  'company.settings.career.social.description.label': 'Share description',
  'company.settings.career.save.title.error': 'Title is required',
  'company.settings.career.save.description.error': 'Description is required',
  'company.settings.save.empty.languages': 'Unable to save. You need to select at least one career page language',
  'company.settings.joborder.heading': 'Career site job ordering',
  'company.settings.joborder.desciption': 'Pin the published jobs that you want to specifically order on the career site, jobs that are not pinned are ordered by publish date below pinned jobs.',
  'company.settings.joborder.pinned': 'Pinned to top',
  'company.settings.joborder.pin.hover': 'Pin job to top',
  'company.settings.joborder.unpin.hover': 'Unpin job ',
  'company.settings.joborder.unpinned': 'Un-pinned jobs',
  'company.settings.joborder.pinned.none': 'No jobs pinned to top',
  'company.settings.joborder.unpinned.none': 'No jobs ordered by publish date',
  'company.settings.joborder.manually': 'Manually ordered',
  'company.settings.joborder.unpinned.order': 'Publish date • newest to oldest',
  'company.settings.joborder.move.top': 'Move to top',
  'company.settings.joborder.move.bottom': 'Move to bottom',
  'company.settings.joborder.toast.job': 'Job re-ordered on career site',
  'company.settings.joborder.toast.department': 'Department re-ordered on career site',
  'company.settings.joborder.toast.get.error': 'Could not get jobs',
  'company.settings.joborder.departments.unpinned.order': 'Date created • newest to oldest',
  'company.settings.joborder.departments.desciption': 'Pin the published jobs that you want to specifically order on the career site, Departments and jobs that are not pinned are ordered by publish date below pinned departments and jobs.',
  'company.settings.joborder.departments.pinned': 'Pinned to top in department',
  'company.settings.joborder.departments.unpinned': 'Un-pinned departments',
  'company.settings.joborder.departments.pinned.none': 'No departments pinned to top',
  'company.settings.joborder.departments.unpinned.none': 'No departments ordered by date created',
  'company.settings.joborder.departments.jobs.none': 'No jobs currently published in department',
  'company.settings.joborder.departments.pin.hover': 'Pin department to top',
  'company.settings.joborder.departments.unpin.hover': 'Unpin department ',
  'sharejob.careersite.maintext': 'This is a permanent link that references your 50skills career page. This is the recommended way to share your job listings.',
  'sharejob.careersite.title': 'Share career page',
  'sharejob.header.crumb.root': 'Sharing',
  'sharejob.header.sharing.title': 'Social sharing',
  'sharejob.header.crumb.careers': 'Career page',
  'sharejob.button.careers': 'Share career page',
  'sharejob.tips.reward': 'Job has reward for a referral that leads to a hire',
  'sharejob.tips.social': 'Share this job on social media',
  'sharejob.button.submit': 'Share job',
  'sharejob.label': 'Applicants who apply through your personal referral link will be labeled as sourced by you.',
  'modals.sso.header': 'Sign in to 50skills with SSO',
  'modals.sso.email': 'Email',
  'modals.sso.errors.account_not_configured': 'Your account is not configured to use SSO. Please log in with a password.',
  'modals.sso.errors.company_not_configured': 'Your company is not configured to use SSO. Please contact 50skills to enable it.',
  'modals.sso.button.cancel': 'Cancel',
  'modals.sso.button.signin': 'Sign in',
  'signin.twofactor.heading': 'Two factor authentication',
  'signin.twofactor.subheading': 'Enter your authenticator passcode',
  'signin.twofactor.label.code': 'Code',
  'signin.twofactor.button.submit': 'Verify',
  'signin.twofactor.button.submitting': 'Verifying...',
  'signin.twofactor.button.sendingsms': 'Sending sms...',
  'signin.twofactor.sms': 'Send SMS with code',
  'signin.sms.heading': 'SMS authentication',
  'signin.sms.subheading': 'Enter the code sent via sms',
  'slack.success.bot': 'Slack Bot installed',
  'slack.success.user': 'Slack Account linked',

  'user.unknown': 'Unknown user',

  'user.create.heading': 'Create a new user',
  'user.create.label.name': 'Name',
  'user.create.label.email': 'Email',
  'user.create.label.role': 'Role',
  'user.role.user.help': 'Can only access the job-ad sharing-page',
  'user.role.limited.help': 'Can only access specific applications',
  'user.role.recruiter.help': 'Can see and work with selected jobs',
  'user.role.admin.help': 'Full edit rights on eligible jobs & manage users',
  'user.role.superadmin.help': 'Unrestricted access to manage all jobs, applicants and users',

  'user.sendinvite.error': 'Unable to send invite email, please contact 50skills',
  'user.sendinvite.success': 'Invite sent',

  'user.create.sendinvite.toggle': 'Send invite',
  'user.create.addtonewjobs.toggle': 'Automatically add to new jobs',
  'user.create.addtonewjobs.tooltip': 'This user will automatically be added to hiring teams when creating new jobs',
  'user.create.addtohiredapplications.toggle': 'Automatically add to hired applicants',
  'user.create.addtohiredapplications.tooltip': 'This user will automatically be granted access to hired applicants in jobs with limited access.',
  'user.create.button.cancel': 'Cancel',
  'user.create.button.submit': 'Save',

  'user.edit.update.errors': 'Unable to edit user. Check form errors and please contact 50skills support.',
  'user.edit.update.success': 'User information successfully updated',
  'user.edit.heading': 'Edit user',
  'user.accessform.heading': 'Job access',
  'user.accessform.applicants': 'Applicants',
  'user.accessform.draft': 'Draft',
  'user.accessform.select': 'Select all',
  'user.accessform.deselect': 'Deselect all',

  'user.tabs.all': 'All users',
  'user.tabs.superadmins': 'Super-admins',
  'user.tabs.admins': 'Admins',
  'user.tabs.recruiters': 'Recruiters',
  'user.tabs.limited': 'Limited team members',
  'user.tabs.employees': 'Employees',
  'user.tabs.mobile.display': 'Show: {0}',
  'user.button.create': 'Add user',
  'user.search.tip': 'Search',

  'user.status.joined': 'Joined',
  'user.status.created': 'Created',
  'user.status.invited': 'Invited',
  'user.access.loading': 'Loading...',
  'user.access.all': 'All',
  'user.access.sharingonly': 'Sharing page only',
  'user.access.jobs.singular': 'job',
  'user.access.jobs.plural': 'jobs',
  'user.access.apps.singular': 'application',
  'user.access.apps.plural': 'applications',
  'user.options.edit': 'Edit',
  'user.options.view': 'Profile',
  'user.options.delete': 'Delete',
  'user.options.invite': 'Send invite',

  'user.crumbs.team': 'Team',
  'user.tabs.profile': 'Profile',
  'user.tabs.security': 'Security',
  'user.tabs.notifications': 'Notifications',
  'user.tabs.twofactor': 'Two-Factor',
  'user.changepw.heading': 'Change password',
  'user.twofactor.heading': 'Two factor authentication',
  'user.twofactor.subheading': 'Keep your account extra secure with two factor authentication',
  'user.twofactor.label.authenticator': 'Authenticator app',
  'user.twofactor.label.authenticator.connected': 'Connected',
  'user.twofactor.label.code': '6 Digit Code from application',
  'user.twofactor.label.phone': 'SMS',
  'user.twofactor.button.addauthenticator': 'Add authenticator',
  'user.twofactor.button.addsms': 'Add SMS fallback',
  'user.twofactor.button.submit': 'Submit',
  'user.twofactor.success': 'Device Saved',

  'user.list.empty.header': 'No users found',
  'user.list.empty.content': 'No users matching current filters',
  'user.list.departments.none': 'No department',

  'profile.apps.subheader': '50skills API is under active development.',
  'profile.apps.subheader.docs': 'API Documentation',
  'profile.apps.heading': '50skills API',
  'profile.apps.personal': 'Personal API keys',
  'profile.apps.personal.info': 'Create your personal keys for accessing and authenticating with the 50skills external API.',
  'profile.apps.loading.error': 'Unable to fetch user apps',
  'profile.apps.add': 'Add new user app',
  'profile.apps.menu.remove': 'Remove user app',

  'notifications.title': 'Notifications',
  'notifications.search.placeholder': 'Search...',
  'notifications.tabs.label': 'Notifications filter',
  'notifications.tabs.activity': 'Activity',
  'notifications.tabs.archive': 'Archived',
  'notifications.filters.all': 'All',
  'notifications.filters.unread': 'Unread',
  'notifications.filters.newapplications': 'New applications',
  'notifications.filters.assigned': 'Assigned to me',
  'notifications.empty.header': 'No notifications',
  'notifications.empty.content': 'We\'ll show notifications on all new activity you are subscribed to here',
  'notifications.title.markallasread': 'Mark all as read',
  'notifications.title.archiveall': 'Archive all',
  'notifications.modals.markasread.header': 'Mark as read',
  'notifications.modals.markasread.text': 'Are you sure you want to mark all notifications as read?',
  'notifications.modals.markasread.success': 'All notifications marked as read',
  'notifications.modals.markasread.error': 'Error marking notifications as read, please try again later',
  'notifications.modals.archiveall.header': 'Archive',
  'notifications.modals.archiveall.text': 'Are you sure you want to archive all notifications?',
  'notifications.modals.archiveall.success': 'All notifications archived',
  'notifications.modals.archiveall.error': 'Error archiving notifications, please try again later',
  'notifications.tooltips.markasread': 'Mark as read',
  'notifications.tooltips.markasunread': 'Mark as unread',
  'notifications.tooltips.archive': 'Archive',
  'notifications.tooltips.unarchive': 'Unarchive',
  'notifications.tooltips.settings': 'Settings',
  'notifications.tooltips.close': 'Close',
  'notifications.new_notifications.singular': 'New notification',
  'notifications.new_notifications.plural': 'New notifications',
  'notifications.single.applicant_hired': 'marked',
  'notifications.single.applicant_as_hired': 'as hired',
  'notifications.single.applicant_rejected': 'marked',
  'notifications.single.applicant_rejected_as': 'as rejected',
  'notifications.single.applicant_assigned': 'assigned an applicant,',
  'notifications.single.applicant_assigned_to': ', to you',
  'notifications.single.move_stage': 'moved',
  'notifications.single.move_stage_from': 'from stage',
  'notifications.single.move_stage_to': 'to',
  'notifications.single.job_archived': 'archived a job',
  'notifications.single.job_published': 'published a job',
  'notifications.single.job_expired': 'Job is expired',
  'notifications.single.added': 'added',
  'notifications.single.you': 'You',
  'notifications.single.to_hiring_team': 'to a hiring team',
  'notifications.single.new_applications': 'New application: ',
  'notifications.single.add_rating': 'left a new rating on applicant',
  'notifications.single.add_note': 'left a new note on applicant',
  'notifications.single.add_note_mention': 'mentioned you in a note on applicant',
  'notifications.single.bulk_reject': 'group rejected',
  'notifications.single.bulk_reject_applicants': 'applicants',
  'notifications.addtoapplication': 'gave you access on application, ',
  'notifications.integrations.onboarding_form.send': 'sent an onboarding form to',
  'notifications.integrations.onboarding_form.finished_new': 'Onboardee',
  'notifications.integrations.onboarding_form.finished_has': 'has completed an onboarding form',
  'notifications.integrations.signet.finished_new': 'Onboardee',
  'notifications.integrations.signet.finished_has': 'has signed a Signet contract',
  'notifications.single.message': 'New message on applicant',
  'notifications.single.add_job_note': 'left a new note on job',
  'notifications.single.add_job_note_mention': 'mentioned you in a note on job',

  'user.profile.error.email': 'Invalid e-mail entered.',
  'user.profile.error.generic': 'Unable to save user. {0} Please contact 50skills support.',
  'user.profile.update.success': 'User information successfully updated',
  'user.profile.label.image': 'Profile Image',
  'user.profile.image.choose': 'Choose file',
  'user.profile.image.nofile': 'No file chosen',
  'user.profile.label.name': 'Name',
  'user.profile.label.email': 'Email',
  'user.profile.label.language': 'Language',
  'user.profile.label.language.english': 'English',
  'user.profile.label.language.icelandic': 'Icelandic',
  'user.profile.button.cancel': 'Cancel',
  'user.profile.button.submit': 'Save',
  'user.social.heading': 'Social',

  'user.profile.settings.notifications.mail.header': 'Mail',
  'user.profile.settings.notifications.mail.text': 'Sent to your email inbox',
  'user.profile.settings.notifications.inapp.header': 'In-app',
  'user.profile.settings.notifications.inapp.text': 'Notification in the bottom left corner',
  'user.profile.settings.notifications.activity.header': 'Activity notifications',
  'user.profile.settings.notifications.activity.subheader': 'Get notified about applicant & hiring activity',
  'user.profile.settings.notifications.table.header.notify': 'Notify me when',
  'user.profile.settings.notifications.table.header.mail': 'Mail',
  'user.profile.settings.notifications.table.header.inapp': 'In-app',
  'user.profile.settings.notifications.table.applicant.header': 'Applicant notifications',
  'user.profile.settings.notifications.table.applicant.applies': 'An applicant applies for a job',
  'user.profile.settings.notifications.table.applicant.movestage': 'An applicant moves to another stage',
  'user.profile.settings.notifications.table.applicant.addtohiringteam': 'You are added to a hiring team',
  'user.profile.settings.notifications.table.applicant.addtoapplication': 'You are given access to an application',
  'user.profile.settings.notifications.table.applicant.bulkrejectapplicants': 'Applicants are group rejected',
  'user.profile.settings.notifications.table.applicant.addrating': 'An applicant receives a rating',
  'user.profile.settings.notifications.table.applicant.addnote': 'An applicant receives a new note',
  'user.profile.settings.notifications.table.applicant.addnotemention': 'You are mentioned in an applicant note',
  'user.profile.settings.notifications.table.applicant.applicanthired': 'An applicant is hired',
  'user.profile.settings.notifications.table.applicant.applicantrejected': 'An applicant is rejected',
  'user.profile.settings.notifications.table.applicant.applicantassigned': 'An applicant is assigned to you',
  'user.profile.settings.notifications.table.applicant.applicationmessage': 'An applicant sends in a new message',
  'user.profile.settings.notifications.table.applicant.applicationassignedmessage': 'An applicant assigned to you sends in a new message',
  'user.profile.settings.notifications.table.job.header': 'Job notifications',
  'user.profile.settings.notifications.table.job.publishjob': 'A job is published',
  'user.profile.settings.notifications.table.job.archivejob': 'A job is archived',
  'user.profile.settings.notifications.table.job.expirejob': 'A job is expired',
  'user.profile.settings.notifications.table.job.addjobnote': 'A note has been added to a job',
  'user.profile.settings.notifications.table.job.addjobnotemention': 'You are mentioned in a job note',
  'user.profile.settings.notifications.table.onboarding.header': 'Onboarding notifications',
  'user.profile.settings.notifications.table.onboarding.integration': 'Onboarding form is sent or received',
  'user.profile.settings.notifications.save.success': 'Notification settings saved',
  'user.profile.settings.notifications.save.error': 'Unable to save notification settings',

  'company.templates.default.yes': 'Yes',
  'company.templates.default.no': 'No',
  'company.templates.tasklist.header': 'Task lists',
  'company.templates.tasklist.label.name': 'Name',
  'company.templates.tasklist.menu.edit': 'Edit template',
  'company.templates.crumbs.root': 'Templates',
  'company.templates.crumbs.new': 'New template',
  'company.templates.tabs.tasks': 'Tasks',
  'company.templates.tabs.label': 'Template selection',
  'company.templates.tabs.emails': 'Emails',
  'company.templates.emails.new': 'New email template',
  'company.templates.tasks.new': 'New tasklist template',
  'company.templates.options.edit': 'Edit',
  'company.templates.options.delete': 'Delete',
  'company.templates.update.success': 'Tasklist successfully updated',
  'company.templates.update.error': 'Unable to update tasklist. Please contact 50skills support.',
  'company.templates.create.success': 'Tasklist successfully created',
  'company.templates.create.error': 'Unable to create tasklist. Please contact 50skills support.',
  'company.templates.tasks.create': 'Add task',
  'company.templates.tasks.label.title': 'Title',
  'company.templates.tasks.label.title.placeholder': 'Write your task name',
  'company.templates.tasks.label': 'Task name',
  'company.templates.button.add.task': 'Add',
  'company.templates.button.update.task': 'Update',
  'company.templates.button.cancel.task': 'Cancel',
  'company.templates.tasks.label.tasks': 'Tasks',
  'company.templates.type.applicant_new_application': 'New Application',
  'company.templates.type.rejection': 'Rejection',
  'company.templates.type.message': 'Message',
  'company.templates.email.tabs.all': 'All',
  'company.templates.email.tabs.new_application': 'New application',
  'company.templates.email.tabs.rejection': 'Rejection',
  'company.templates.email.tabs.message': 'Message',
  'company.templates.email.button.cancel': 'Cancel',
  'company.templates.email.button.save': 'Save',
  'company.templates.email.button.back': 'Back',
  'company.templates.email.create.error': 'Unable to create template. Please contact 50skills.',
  'company.templates.email.create.success': 'Template successfully created ',
  'company.templates.email.create.success.default': 'Template successfully created and set as default reply for all applications',
  'company.templates.email.delete.error': 'Unable to delete email template. Please contact 50skills.',
  'company.templates.email.delete.success': 'Successfully deleted email template.',
  'company.templates.email.delete.text': 'Are you sure you want to remove the template',
  'company.templates.email.menu.delete': 'Delete template',
  'company.templates.email.menu.edit': 'Edit template',
  'company.templates.email.menu.view': 'View template',
  'company.templates.email.message.placeholder': 'Compose a new e-mail template',
  'company.templates.email.title.placeholder': 'Choose a descriptive title for the template',
  'company.templates.email.subject.placeholder': 'Choose a subject for the e-mail',
  'company.templates.email.update.error': 'Unable to update template. {0}.',
  'company.templates.email.update.success': 'Template saved',
  'company.templates.email.update.success.default': 'Template saved and set as default reply for all applications',
  'company.templates.email.label.message': 'Message',
  'company.templates.email.label.title': 'Title',
  'company.templates.email.label.type': 'Type',
  'company.templates.email.label.default': 'Default',
  'company.templates.email.label.options': 'Options',
  'company.templates.email.type.title': 'Select type',
  'company.templates.email.label.setdefault': 'Set as default email reply for all applications',
  'company.integrations.configured_apps': 'Configured apps',
  'company.integrations.upsell.title': 'More apps available',
  'company.integrations.none': 'No integrations configured',
  'company.integrations.upsell.body': 'To connect internal chat software such as Workplace, Slack or integrate with some of your existing HR software, please contact us.',
  'company.integrations.detail.hired': 'Hired • {0} • by {1}',

  'comparers.is': 'Is...',
  'comparers.not_is': 'Is not...',
  'comparers.any_of': 'Is any of...',
  'comparers.none_of': 'Is none of...',
  'comparers.starts': 'Starts with...',
  'comparers.not_starts': 'Does not start with...',
  'comparers.contains': 'Contains',
  'comparers.not_contains': 'Does not contain',

  'comparers.is_rated_by': 'Is rated by...',
  'comparers.not_is_rated_by': 'Is not rated by...',
  'comparers.is_none': 'No rating',

  'comparers.today': 'Today',
  'comparers.yesterday': 'Yesterday',
  'comparers.gt': 'More than',
  'comparers.between': 'Between',
  'comparers.eq': 'Exactly',
  'comparers.lt': 'Less than',
  'comparers.after': 'After',
  'comparers.on': 'On',
  'comparers.before': 'Before',

  'filters.daysago': 'days ago',
  'filters.years': 'years',
  'filters.loading': 'Loading...',
  'filters.add': 'Add filter',
  'filters.clear': 'Clear filters',
  'filters.conj.and': 'And',
  'filters.conj.or': 'Or',
  'filters.remove': 'Remove',
  'filters.update': 'Update filter',
  'filters.apply': 'Apply filter',
  'filters.toggle': 'Filter',

  'applicants.status.title': 'Application status',
  'applicants.status.active': 'Active',
  'applicants.status.hired': 'Hired',
  'applicants.status.rejected': 'Rejected',
  'applicants.status.retracted': 'Retracted',

  'applicants.filters.stage.label': 'Stage',
  'applicants.filters.question.label': 'Question response',

  'applicants.filters.language.label': 'Language',

  'applicants.filters.integrations.all': 'All',
  'applicants.filters.integrations.not_started': 'Not started',
  'applicants.filters.integrations.in_progress': 'In progress',
  'applicants.filters.integrations.completed': 'Completed',


  'applicants.filters.job.title': 'Job',
  'applicants.filters.job.notitle': 'No title set',
  'applicants.filters.job.state': 'Status: {0}',
  'applicants.filters.job.showing': 'Showing first 8',

  'applicants.filters.integration.title': 'Integration status',

  'applicants.filters.personal.title': 'Personal details',
  'applicants.filters.personal.name': 'Name',
  'applicants.filters.personal.email': 'Email',
  'applicants.filters.personal.phone': 'Phone',
  'applicants.filters.personal.cv': 'CV',
  'applicants.filters.personal.cover_letter': 'Cover letter',
  'applicants.filters.personal.notes': 'Notes',
  'applicants.filters.personal.messages': 'Messages',


  'applicants.filters.assigned.title': 'Assigned to',
  'applicants.filters.assigned.me': 'Me',
  'applicants.filters.assigned.none': 'No one',
  'applicants.filters.assigned.anyone': 'Anyone',

  'applicants.filters.date.title': 'Date',
  'applicants.filters.date.hired': 'Hired',
  'applicants.filters.date.rejected': 'Rejected',
  'applicants.filters.date.applied': 'Applied',
  'applicants.filters.date.rel': 'Relative',
  'applicants.filters.date.abs': 'Absolute',

  'applicants.filters.label.title': 'Label',
  'applicants.filters.label.notified': 'Rejected and notified',
  'applicants.filters.label.sourced': 'Sourced',
  'applicants.filters.label.manuallyadded': 'Manually added',

  'applicants.filters.rating.title': 'Rating',
  'applicants.filters.rating.-': 'No rating',
  'applicants.filters.rating.S': 'Strong yes',
  'applicants.filters.rating.Y': 'Yes',
  'applicants.filters.rating.N': 'No',
  'applicants.filters.rating.D': 'Definite no',
  'applicants.filters.rating.withmine': 'I have rated',
  'applicants.filters.rating.withoutmine': 'I have not rated',

  'applicants.filters.unread.title': 'Unread activity',
  'applicants.filters.unread.new_application': 'New application',
  'applicants.filters.unread.messages': 'Messages',
  'applicants.filters.unread.notes': 'Notes',
  'applicants.filters.unread.ratings': 'Ratings',
  'applicants.filters.unread.assigned_to': 'Assignments',
  'applicants.filters.unread.files': 'Files',

  'applicants.filters.showing': 'Showing {0} / {1} applicants',

  'applicants.filters.national_registry.title': 'National registry',
  'applicants.filters.national_registry.name': 'Name',
  'applicants.filters.national_registry.gender': 'Gender',
  'applicants.filters.national_registry.ssn': 'SSN / ID number',
  'applicants.filters.national_registry.age': 'Age',
  'applicants.filters.national_registry.age_year_end': 'Age at end of year',
  'applicants.filters.national_registry.street': 'Street',
  'applicants.filters.national_registry.city': 'City',
  'applicants.filters.national_registry.postal_code': 'Postal code',

  'applicants.header.search.placeholder': 'Name, email, phone...',
  'applicants.header.filter': 'Filter',
  'applicants.header.hideall': 'Hide all',
  'applicants.header.expandall': 'Expand all',

  'applicants.empty.header': 'No applicants',
  'applicants.empty.content': 'When someone applies to one of your jobs, they will appear here',

  'onboarding.tabs.label': 'Onboarding status selection',
  'onboarding.tabs.in_progress': 'In Progress',
  'onboarding.tabs.completed': 'Completed',
  'onboarding.empty.header': 'No applicants in onboarding',
  'onboarding.empty.content': 'When you hire an applicant, they will appear here',
  'onboarding.empty.completed.header': 'No applicants have completed onboarding',
  'onboarding.empty.completed.content': 'When an applicant completes onboarding, they will appear here',

  'onboarding.filters.header': 'Onboarding filters',
  'onboarding.filters.sub_header': 'Showing {0} hired applicants',
  'onboarding.sidebar.title.integrations': 'Integration status',
  'onboarding.none_found.no_filters.header': 'No applicants in onboarding',
  'onboarding.none_found.filters.header': 'No applicants found',
  'onboarding.none_found.no_filters.sub_header': 'There are no applicants currently being onboarded',
  'onboarding.none_found.filters.sub_header': 'No applicants matching current filters',
  'job.filters.numfilteredout': '{0} applicant(s) filtered out',
  'job.filters.clear': 'clear filters',
  'job.filters.empty': 'No applicants filtered out',
  'job.tabs.label': 'Job selection',
  'job.tabs.pipeline': 'Pipeline',
  'job.tabs.promote': 'Job boards',
  'job.tabs.applicants': 'Applicants',
  'job.tabs.info': 'Job info',
  'job.tabs.access': 'Access',
  'job.tabs.statistics': 'Statistics',
  'job.tabs.integrations': 'Apps',
  'job.tabs.journeys': 'Journeys',
  'job.addapplicant': 'Add applicant',
  'job.access.manage': 'Manage access',
  'job.access.editaccess.addapplicant': 'Add applicant',
  'errors.field.required': 'This field is required',
  'modals.addapplicant.header': 'Add applicant',
  'modals.addapplicant.label.name': '',
  'modals.addapplicant.button.cancel': 'Cancel',
  'modals.addapplicant.button.submit': 'Save',
  'modals.addapplicant.field.cv': 'CV/Resumé',
  'modals.addapplicant.field.cover': 'Cover Letter',
  'modals.addrecruiter.heading': 'Add to hiring team',
  'modals.addrecruiter.select.empty': 'No users available',
  'modals.addrecruiter.select': 'Select users to add to the hiring team',
  'modals.addrecruiter.button.cancel': 'Cancel',
  'modals.addrecruiter.button.submit': 'Add',
  'job.applicants.show.selected': "{0} filtered applicants are selected",
  'job.applicants.show.selected.all': "All {0} filtered applicants are selected",
  'job.applicants.selection.clear': "Clear selection",
  'job.applicants.filtered.applicants': "Select all {0} filtered applicants",
  'job.applicants.empty': 'No applicants',
  'job.applicants.empty.search': 'No applicants found',
  'job.applicants.msg.search': 'No applicants matching current filters',
  'job.applicants.msg.all': 'All applicants will appear here',
  'job.applicants.msg.rejected': 'Rejected applicants will appear here',
  'job.applicants.label.name' : 'Name',
  'job.applicants.label.email' : 'Email',
  'job.applicants.label.job' : 'Job',
  'job.applicants.label.applied' : 'Applied',
  'job.applicants.label.stage' : 'Stage',
  'job.applicants.label.reviews' : '# Ratings',
  'job.applicants.label.avgrating' : 'AVG Rating',
  'job.applicants.label.messages' : '# Messages',
  'job.applicants.label.notes' : '# Notes',
  'job.applicants.label.options' : 'Options',
  'job.applicants.label.status' : 'Status',
  'job.applicants.label.labels' : 'Labels',

  'job.info.tabs.details': 'Details',
  'job.info.tabs.notes': 'Notes',
  'job.info.tabs.files': 'Files',
  'job.info.details.header': 'Details',
  'job.info.details.language.english': 'English',
  'job.info.details.language.icelandic': 'Icelandic',
  'job.info.details.jobdetails.header': 'Job details',
  'job.info.details.jobdetails.jobtitle': 'Job title',
  'job.info.details.jobdetails.worktype': 'Work type',
  'job.info.details.jobdetails.location': 'Location',
  'job.info.details.jobdetails.department': 'Department',
  'job.info.details.jobdetails.jobstatus': 'Job status',
  'job.info.details.jobdetails.visibility': 'Visibility',
  'job.info.details.jobdetails.deadline': 'Application deadline',
  'job.info.details.jobdetails.published': 'Last published',
  'job.info.details.jobdetails.createdby': 'Created by',
  'job.info.details.jobdetails.labels': 'Job labels',
  'job.info.details.jobdescription.header': 'Job description',
  'job.info.details.jobdescription.shortdescription': 'Short description',
  'job.info.details.jobdescription.longdescription': 'Long description',
  'job.info.details.applicationform.header': 'Application form',
  'job.info.details.applicationform.name': 'Name',
  'job.info.details.applicationform.email': 'Email',
  'job.info.details.applicationform.ssn': 'SSN / ID Number',
  'job.info.details.applicationform.phone': 'Phone',
  'job.info.details.applicationform.cv': 'CV / Resumé',
  'job.info.details.applicationform.coverletter': 'Cover letter',
  'job.info.details.applicationform.options.alwaysrequired': 'Always required',
  'job.info.details.applicationform.options.required': 'Required',
  'job.info.details.applicationform.options.optional': 'Optional',
  'job.info.details.applicationform.options.off': 'Off',
  'job.info.details.questions.header': 'Questions',

  'job.info.notes.header': 'Notes',
  'job.info.notes.textbox.adminnote.label': 'Admin Note',
  'job.info.notes.textbox.switch.admin': 'Admin Note',
  'job.info.notes.textbox.info': 'Admin notes are only visible to admins',
  'job.info.notes.adminonly': 'Only visible to admins',
  'job.info.notes.textbox.placeholder.admin': 'Add an admin note - only other admin users can see these notes',
  'job.info.notes.textbox.placeholder.regular': 'Add a note or @ mention your co-workers to notify them',
  'job.info.notes.textbox.button.submit.admin': 'Save admin note',
  'job.info.notes.textbox.button.submit.regular': 'Save note',
  'job.info.notes.edit.button.cancel': 'Cancel',
  'job.info.notes.edit.button.submit': 'Update',
  'job.info.notes.actions.edit': 'Edit',
  'job.info.notes.actions.delete': 'Delete',
  'job.info.notes.add.success': 'Note added',
  'job.info.notes.add.error': 'Unable to add note, please contact 50skills support',
  'job.info.notes.update.success': 'Note updated',
  'job.info.notes.update.error': 'Unable to update note, please contact 50skills support',
  'job.info.notes.remove.confirm': 'Are you sure you wish to delete this note?',
  'job.info.notes.remove.success': 'Note deleted',
  'job.info.notes.remove.error': 'Unable to delete note, please contact 50skills support',

  'job.info.files.header': 'Files',
  'job.info.files.converttext': 'Please note in order to be able to preview files in the browser we try to convert them to PDF. You are still able to download the original file',
  'job.info.files.empty': 'No files added',
  'job.info.files.addedby': 'Added by {0}',
  'job.info.files.download': 'Download',
  'job.info.files.remove': 'Remove',
  'job.info.files.upload': 'Upload file',
  'job.info.files.upload.success': 'File uploaded',
  'job.info.files.upload.error': 'Unable to upload file. Please contact 50skills',
  'job.info.files.remove.confirm': 'Are you sure you want to delete this file?',
  'job.info.files.remove.success': 'File removed',
  'job.info.files.remove.error': 'Unable to remove file. Please contact 50skills',

  'onboarding.applicants.label.name' : 'Name',
  'onboarding.applicants.label.hired' : 'Hired',
  'onboarding.applicants.label.job' : 'Job',
  'onboarding.applicants.label.status' : 'Onboarding status',
  'onboarding.applicants.status': '{0} of {1} completed',
  'onboarding.applicants.status.completed': 'Completed',
  'onboarding.applicants.status.inprogress': 'In progress',
  'onboarding.applicants.status.notstarted': 'Not started',
  'application.label.sourced' : 'Sourced',
  'application.label.notified' : 'Rejected and notified',
  'application.label.new' : 'New',
  'application.label.manuallyadded' : 'Manually added',
  'job.statistics.bystage': 'Applicants by stage',
  'job.statistics.overview.summary': 'Summary',
  'job.statistics.overview.applicants': 'Total applicants',
  'job.statistics.overview.views': 'Total views',
  'job.statistics.overview.cleared': 'Expired applicants (GDPR)',
  'job.statistics.overview.status': 'Status',
  'job.statistics.overview.hired': 'Hired',
  'job.statistics.overview.active': 'Active',
  'job.statistics.overview.rejected': 'Rejected',
  'job.statistics.overview.retracted': 'Retracted',
  'job.statistics.overview.source': 'Source',
  'job.statistics.overview.direct': 'Direct',
  'job.statistics.overview.sourced': 'Sourced',
  'job.statistics.overview.manual': 'Manual adds',
  'job.statistics.sourcing.heading': 'Top sourcing employees',
  'job.statistics.sourcing.empty': 'No applicants were sourced by employees',
  'job.statistics.applicants': 'Applicants',
  'job.statistics.hired': 'Hired',
  'job.statistics.traffic.heading': 'Traffic sources',
  'job.statistics.traffic.empty': 'No traffic sources found',
  'job.filters.tip.stages': 'Job stages view',
  'job.filters.tip.list': 'Applicant list view',
  'job.filters.tip.search': 'Search',
  'job.sidebar.title.filters': 'Job filters',
  'job.sidebar.title.language': 'Language',
  'job.sidebar.stagefilter.all': 'All',
  'job.sidebar.languagefilter.all': 'All',
  'job.sidebar.assignedtofilter.anyone': 'Anyone',
  'job.sidebar.assignedtofilter.none': 'No one',
  'job.sidebar.assignedtofilter.me': 'Me',
  'job.sidebar.filters.showing': 'Showing {0} / {1} applicants',
  'job.sidebar.title.show': 'Show',
  'job.sidebar.active': 'Active',
  'job.sidebar.hired': 'Hired',
  'job.sidebar.rejected': 'Rejected',
  'job.sidebar.retracted': 'Retracted',
  'job.sidebar.title.labels': 'Labels',
  'job.sidebar.labels.none': 'No Label',
  'job.sidebar.labels.manual': 'Manually added',
  'job.sidebar.labels.sourced': 'Sourced',
  'job.sidebar.labels.rejectionsent': 'Rejection sent',
  'job.sidebar.title.avg': 'Average rating',
  'job.sidebar.avg.none': 'No reviews',
  'job.sidebar.avg.strongy': 'Strong yes',
  'job.sidebar.avg.yes': 'Yes',
  'job.sidebar.avg.no': 'No',
  'job.sidebar.avg.defno': 'Definite no',
  'job.sidebar.title.stage': 'Stage',
  'job.sidebar.title.assignment': 'Assigned to',
  'job.sidebar.title.byq': 'By question response',
  'job.sidebar.title.job': 'Job',
  'job.sidebar.title.jobs': 'Jobs',
  'job.sidebar.removefilter': 'Remove filter',
  'job.sidebar.chooseq': 'Choose question',
  'job.sidebar.choosea': 'Choose answer',
  'modals.grantmulti.heading': 'Grant single applicant access',
  'modals.grantmulti.applicantsmsg': 'Are you sure you want to grant access to the following candidates:',
  'modals.grantmulti.label': 'Team members',
  'modals.grantmulti.users.select': 'Select users that should have access these applicants',
  'modals.grantmulti.users.empty': 'No users available',
  'modals.grantmulti.button.cancel': 'Cancel',
  'modals.grantmulti.button.submit': 'Grant access',
  'modals.movetostage.heading': 'Move to stage',
  'modals.movetostage.applicantsmsg': 'Are you sure you want move the following applicants:',
  'modals.movetostage.stagemsg': 'To the following stage:',
  'modals.movetostage.stage.select': 'Select new stage',
  'modals.movetostage.button.cancel': 'Cancel',
  'modals.movetostage.button.submit': 'Move',
  'job.integrations.button.submit': 'Submit',
  'job.integrations.list.title': 'Apps',
  'job.integrations.list.empty': 'No custom integrations configured. Want to connect third-party software to your hiring process? Contact info@50skills.com for more details.',
  'job.integrations.empty.title': 'No integrations configured',
  'job.integrations.empty.text': 'If you want to connect your company\'s internal communication software e.g. Slack, Facebook Workplace or any other similar software, please contact us!',
  'job.applications.search.tip': 'Name, email, phone...',
  'application.onboarding.crumb.onboard' : 'Onboard',
  'application.onboarding.tabs.label' : 'Onboarding selection',
  'application.onboarding.tabs.details' : 'Details',
  'application.onboarding.tabs.sourcing' : 'Sourcing Rewards',
  'application.onboarding.tip.ssn_only': 'Does not match national registry records ({0}) but was accepted',
  'application.onboarding.tip.keep_or_match': 'Does not match national registry records ({0})',
  'application.onboarding.tip.error': 'SSN / ID number not found in national registry records',
  'application.onboarding.applied': 'Applied',
  'application.onboarding.label.name': 'Name',
  'application.onboarding.label.phone': 'Phone',
  'application.onboarding.label.email': 'Email',
  'application.onboarding.label.ssn': 'SSN / ID number',
  'application.onboarding.verifyssn.keepormatch': '<span>Name</span> does not match records of the national registry: {0}',
  'application.onboarding.button.keep': 'Keep name',
  'application.onboarding.button.match': 'Update to match',
  'application.onboarding.button.verify': 'Verify',
  'application.onboarding.button.again': 'Re-verify SSN / ID number',
  'application.onboarding.unverified': 'Verify you have the correct <span>Name</span> and <span>SSN / ID number</span> through the national registry.',
  'application.onboarding.changetemplate.text' : 'Are you sure you want to change templates? Current tasklist will be removed',
  'application.onboarding.removetemplate.text' : 'Are you sure you want to remove the selected template? Current tasklist will be removed',
  'application.onboarding.tasklist.nocreated' : 'No task lists created',
  'application.onboarding.tasklist.create' : 'Create task list',
  'application.onboarding.tasklist.heading': 'Task list',
  'application.onboarding.tasklist.choose': 'Choose template',
  'application.onboarding.tasklist.remove': 'Remove task list',
  'application.onboarding.integration.cancel': 'Cancel',
  'application.onboarding.integration.save': 'Save',
  'application.onboarding.integration.resend': 'Resend',
  'application.onboarding.integration.submit': 'Submit',
  'application.onboarding.integration.delete': 'Delete',
  'application.onboarding.integration.remove': 'Remove',
  'application.onboarding.integration.preview': 'Preview',
  'application.onboarding.rewards.header': 'Sourcing rewards',
  'application.onboarding.rewards.norewards': 'No reward has been set for this job',
  'application.onboarding.rewards.sourcedby': 'Sourced by',
  'application.onboarding.rewards.nosource': 'Nobody sourced this applicant.',
  'application.onboarding.mark_onboarded': 'Mark as onboarded',
  'application.onboarding.unmark_onboarded': 'Unmark as onboarded',
  'application.onboarding.integrations.linked': 'This field receives its default value from {0}',
  'application.onboarding.integrations.linked.application': 'the application',
  'job.recruiters.actions.revoke': 'Revoke job access',
  'job.recruiters.access.isjobfollower': 'All applicants',
  'job.recruiters.access.applicants': '{0} applicant(s)',
  'job.recruiters.editaccess.select': 'Select applicants to grant permissions to',
  'job.recruiters.editaccess.noselect': 'No applicants available',
  'job.recruiters.editaccess.noapplicantsselected': 'No applicants selected.',
  'job.recruiters.editaccess.button.cancel': 'Cancel',
  'job.recruiters.editaccess.button.submit': 'Save',
  'job.recruiters.editaccess.heading': 'Edit application access for {0}',
  'job.recruiters.editaccess.success': 'Successfully changed {0}\'s access',
  'job.recruiters.editaccess.error': 'Unable to change {0}\'s access. Please contact 50skills if the problem persists.',
  'job.access.limitedaccess.modal.search': 'Name, email, phone...',
  'job.access.limitedaccess.modal.noemail': 'No email',
  'job.access.limitedaccess.modal.searching': 'Searching for applicants',
  'job.access.limitedaccess.modal.search.nomatch': 'No applicant found',
  'job.access.limitedaccess.modal.search.noapplicants': 'No more applicants',
  'job.stage.move.error': 'Stage order change failed. Please contact 50skills',
  'job.stages.loadingMore': 'Loading more...',
  'job.stages.menu.sort.title': 'Sort applicants by',
  'job.stages.menu.sort.name-asc': 'Name ascending (A to Z)',
  'job.stages.menu.sort.name-desc': 'Name descending (Z to A)',
  'job.stages.menu.sort.newest': 'Date applied (Newest first)',
  'job.stages.menu.sort.oldest': 'Date applied (Oldest first)',
  'job.stages.menu.sort.notes.highest': 'Number of notes (Highest first)',
  'job.stages.menu.sort.notes.lowest': 'Number of notes (Lowest first)',
  'job.stages.menu.sort.avgvote.highest': 'Average vote (Highest first)',
  'job.stages.menu.sort.avgvote.lowest': 'Average vote (Lowest first)',
  'job.stages.menu.sort.votecount.highest': 'Number of votes (Highest first)',
  'job.stages.menu.sort.votecount.lowest': 'Number of votes (Lowest first)',
  'job.stages.menu.title': 'Stage options',
  'job.stages.menu.applicants': 'Applicants in stage',
  'job.stages.menu.rename': 'Rename stage',
  'job.stages.menu.remove': 'Remove stage',
  'job.stages.menu.sort': 'Sort applicants...',
  'job.stages.menu.message': 'Message',
  'job.stages.menu.hire': 'Hire',
  'job.stages.menu.reject': 'Reject',
  'job.stages.menu.editname.tip.submit': 'Save stage name',
  'job.stages.menu.editname.tip.cancel': 'Cancel',
  'job.stages.mobile.displaytext': 'Stage: {0}',
  'application.assignee.edit': 'Edit assignee',
  'application.assignee.remove': 'Remove assignee',
  'application.gotoonboarding': 'Onboard',
  'application.access.addmodal.header': 'Grant single applicant access',
  'application.access.addmodal.maintext': 'Give access to this application to users outside the hiring team. They will only be able to view this application and others they have been added to manually.',
  'application.access.addmodal.select': 'Select users to grant them access',
  'application.access.addmodal.button.cancel': 'Cancel',
  'application.access.addmodal.button.submit': 'Add',
  'application.gdpr.header': 'Applicant expired',
  'application.gdpr.maintext': 'Due to the EU General Data Protection Regulation (GDPR), this applicant\'s data has expired and consequently removed.',
  'application.tabs.label': 'Application sections',
  'application.tabs.details': 'Details',
  'application.tabs.contact': 'Contact',
  'application.tabs.notes': 'Notes',
  'application.tabs.messages': 'Messages',
  'application.tabs.ratings': 'Ratings',
  'application.tabs.files': 'Files',
  'application.tabs.access': 'Access',
  'application.tabs.attachments': 'Attachments',
  'application.tabs.apps': 'Apps',
  'application.tabs.journeys': 'Journeys',
  'application.header.applied': 'Applied',
  'application.header.by': 'by {0} / {1}',
  'application.header.answers': 'Application answers',
  'application.header.sourced': 'Sourced by',
  'application.header.access': 'Single candidate access',
  'application.header.assignedto': 'Assigned to {0}',
  'application.header.files': 'Files',
  'application.details.header.applied_to': 'Applied to • {0} other jobs',
  'application.details.header.show_all': 'Show all',
  'application.details.header.collapse': 'Collapse',
  'application.details.header.cv': 'CV / Resume',
  'application.details.header.cl': 'Cover Letter',
  'application.details.ssnregistry.header': 'National Registry Information',
  'application.details.ssnregistry.name': 'Name',
  'application.details.ssnregistry.age': 'Age',
  'application.details.ssnregistry.ageYearEnd': 'Age at end of year',
  'application.details.ssnregistry.ssn': 'SSN / ID Number',
  'application.details.ssnregistry.gender': 'Gender',
  'application.details.ssnregistry.postalCode': 'Postal Code',
  'application.details.ssnregistry.city': 'City',
  'application.details.ssnregistry.street': 'Street',
  'application.details.ssnregistry.no_details': 'No details',
  'application.details.nocvpreview': 'Unable to preview CV',
  'application.details.noclpreview': 'Unable to preview Cover Letter',
  'application.details.nocvuploaded': 'No CV was uploaded',
  'application.details.nocluploaded': 'No Cover Letter was uploaded',
  'application.details.noanswer': '(No answer provided)',
  'application.details.deletedquestion': '(Question deleted from job)',
  'application.details.deletedoption': '(Option deleted from question)',
  'application.details.attachtip': 'Click to view attached file',
  'application.attachment.nopreview': 'Unable to preview Attachment',
  'application.attachment.download': 'Download',
  'application.attachments.add.success': 'Successfully uploaded the file',
  'application.attachments.add.error': 'Error uploading the file',
  'application.attachments.remove.success': 'Successfully removed the file',
  'application.attachments.remove.error': 'Error removing the file',
  'application.clicktodownload': 'Click to download',
  'application.list.allstages': 'All stages',
  'application.list.cardlistname': 'Applicants',
  'application.access.header': 'Hiring team',
  'application.access.roleheader': 'Role',
  'application.access.revoke': 'Revoke Access',
  'application.access.revoking': 'Revoking Access...',
  'application.access.noaccess': 'Applicant is currently not viewable by anyone outside the hiring team',
  'application.access.button.submit': 'Grant access',
  'application.header.contact': 'Contact',
  'application.contact.name': 'Full name',
  'application.contact.email': 'E-mail address',
  'application.contact.phone': 'Phone number',
  'application.contact.ssn': 'SSN / ID number',
  'application.header.social': 'Social profiles',
  'application.contact.link': 'Link',
  'application.contact.nocontent': 'This applicant did not add any social profiles',

  'application.messages.header': 'Messages',
  'application.messages.textbox.button.submit': 'Send message',
  'application.messages.disabled.card': 'Limited team members are not able to send messages directly to applicants',
  'application.messages.send.success': 'Message sent',
  'application.messages.send.error': 'Error occurred',
  'application.messages.editor.placeholder': 'Send a message to the applicant as an e-mail',
  'application.messages.footer.rejection': 'Rejection',
  'application.messages.footer.application': 'Application',
  'application.messages.confirm': 'The following message will be emailed to the applicant {0}:',
  'application.messages.send': 'Send message',
  'application.messages.error': 'Error',
  'application.messages.deliveryfailure': 'Mail delivery failure',

  'application.notes.actions.edit': 'Edit',
  'application.notes.actions.delete': 'Delete',
  'application.notes.header': 'Team notes',
  'application.reviews.nocontent': 'This applicant does not have any reviews from your team yet.',
  'application.reviews.header.you': 'Your rating',
  'application.reviews.header.team': 'Team ratings',
  'application.reviews.average': 'Average rating: {0}',
  'application.notes.edit.button.cancel': 'Cancel',
  'application.notes.edit.button.submit': 'Update',
  'application.notes.textbox.admin_note.label': 'Admin note',
  'application.notes.textbox.switch.admin': 'Admin note',
  'application.notes.textbox.info': 'Admin notes are only visible to admins',
  'application.notes.adminonly': 'Only visible to admins',
  'application.notes.textbox.button.submit.regular': 'Save note',
  'application.notes.textbox.button.submit.admin': 'Save admin note',
  'application.notes.textbox.placeholder.regular': 'Add a note or @ mention your co-workers to notify them',
  'application.notes.textbox.placeholder.admin': 'Add an admin note - only other admin users can see these notes',
  'application.removeconfirm.header': 'Confirm deletion',
  'application.removeconfirm.confirm': 'Are you sure you wish to delete {0}\'s application?',
  'application.removeconfirm.warning': 'This action can not be undone!',
  'application.removeconfirm.button.cancel': 'Cancel',
  'application.removeconfirm.button.submit': 'Confirm',
  'application.rating.no': 'No',
  'application.rating.defno': 'Definite no',
  'application.rating.yes': 'Yes',
  'application.rating.strongyes': 'Strong yes',
  'application.files.add': 'Upload file',
  'application.files.attached': 'Added by',
  'application.files.remove': 'Remove attached file',
  'application.files.nofiles': 'No files added',
  'application.files.download': 'Download original',
  'application.files.hoveropen': 'Click to view file',
  'application.files.nopreview': 'Unable to preview document',
  'application.files.supportedformats': 'Supported file formats: pdf, doc, docx, xls, xlsx, png, jpg, jpeg, gif, bmp, heic. Please note: you can still try downloading the file and opening it on your computer',
  'application.files.converttext': 'Please note in order to be able to preview files in the browser we try to convert them to PDF. You are still able to download the original file',
  'application.move.success': 'Successfully moved {0}\'s application to {1}',
  'application.move.error': 'Unable to move {0}\'s application to {1}. Please contact 50skills.',
  'application.copy.success': 'Successfully copied {0}\'s application to {1}',
  'application.copy.error': 'Unable to copy {0}\'s application to {1}. Please contact 50skills.',
  'application.copy.title': 'Copy application to',
  'application.move.title': 'Move application to',
  'application.movecopy.modal.label.application': 'Application',
  'application.movecopy.modal.label.job': 'Job title',
  'application.movecopy.modal.follow': 'Open application',
  'application.movecopy.modal.follow.copy': 'Open copy',
  'application.movecopy.modal.back': 'Close',
  'application.movecopy.modal.copy.title': 'Application copied',
  'application.movecopy.modal.move.title': 'Application moved',
  'application.movecopy.loadingjobs': 'Loading jobs...',
  'application.movecopy.selectjob': 'Select job',
  'application.movecopy.selectjob.searching': 'Searching for jobs 🕵️',
  'application.movecopy.selectjob.nomatch': 'No jobs matching {0}',
  'application.movecopy.selectjob.nojobs': 'No active jobs',
  'application.movecopy.selectstage': 'Select stage',
  'application.movecopy.label.company': 'Company',
  'application.movecopy.label.job': 'Job',
  'application.movecopy.label.stage': 'Stage',
  'application.movecopy.label.include': 'Include',
  'application.movecopy.label.coverletter': 'Cover letter',
  'application.movecopy.label.notes': 'Notes',
  'application.movecopy.label.files': 'Employee uploaded files',
  'application.movecopy.label.responses': 'Question responses',
  'application.movecopy.label.ratings': 'Ratings',
  'application.movecopy.responses.message': 'You will be prompted to match current job questions to the new job in the next step.',
  'application.movecopy.warning.message': 'Anything you do not include will be lost, this can not be undone.',
  'application.movecopy.button.cancel': 'Cancel',
  'application.movecopy.button.cont': 'Continue',
  'application.movecopy.current.resp': 'Current application responses',
  'application.movecopy.new.resp': 'New job application questions',
  'application.movecopy.button.back': 'Back',
  'application.movecopy.button.move': 'Move',
  'application.movecopy.button.copy': 'Copy',
  'application.movecopy.addfile': 'Click to add file',
  'application.movecopy.addresp': 'Click to add custom response',
  'application.confirmcopy.title': 'Are you sure?',
  'application.confirmcopy.main': 'Not selecting all of the include options will result in them being deleted. Currently you have not selected {0}.',
  'application.confirmcopy.warn': 'This action cannot be undone.',
  'application.confirmcopy.cta': 'Do you wish to proceed?',
  'application.confirmcopy.back': 'No, go back!',
  'application.confirmcopy.proc': 'Proceed',
  'showmore': 'Show more',
  'companies.switchTo': 'Switch to {0}',
  'companies.successfulSwitch': 'Successfully switched companies to {0}',

  // Common integration text
  'integrations.common.settings.connected': 'Connected',
  'integrations.common.settings.notconnected': 'Not connected',
  'integrations.common.settings.disconnect': 'Disconnect',
  'integrations.common.settings.withthis': 'With this integration you can:',

  // AD Manager
  'integrations.admanager.title': 'AD Manager',
  'integrations.admanager.description': 'Create AD usernames for applicants',
  'integrations.admanager.settings.withthis.create': 'Create AD usernames for users',
  'integrations.admanager.settings.helptext': 'Please fill out the form below and press submit',
  'integrations.admanager.settings.authtoken': 'Auth Token',
  'integrations.admanager.settings.baseurl': 'Base URL',
  'integrations.admanager.settings.domainname': 'Domain Name',
  'integrations.admanager.settings.templates.title': 'Templates',
  'integrations.admanager.settings.templates.none.header': 'No templates',
  'integrations.admanager.settings.templates.none.content': 'Add some templates by pressing the + button above',
  'integrations.admanager.settings.templates.header': 'Add template',
  'integrations.admanager.settings.templates.label': 'Template name',
  'integrations.admanager.settings.templates.button.submit': 'Add template',
  'integrations.admanager.settings.templates.add.success': 'Template added',
  'integrations.admanager.settings.templates.add.error': 'Unable to add template',
  'integrations.admanager.settings.templates.delete': 'Remove',
  'integrations.admanager.settings.templates.remove.success': 'Template removed',
  'integrations.admanager.settings.save.success': 'Settings saved',
  'integrations.admanager.settings.save.error': 'Unable to save settings, are you sure the credentials are correct?',
  'integrations.admanager.settings.disconnect.success': 'AD Manager disconnected',
  'integrations.admanager.settings.disconnect.error': 'Unable to disconnect AD Manager',
  'integrations.admanager.job.notconnected': 'App not connected, please go to company settings or ask an admin for help',
  'integrations.admanager.job.templates.label': 'Templates',
  'integrations.admanager.job.save.success': 'Template saved to job',
  'integrations.admanager.job.save.error': 'Unable to save template to job',
  'integrations.admanager.job.remove.success': 'Template removed from job',
  'integrations.admanager.job.remove.error': 'Unable to remove template from job',
  'integrations.admanager.application.button.create': 'Create in AD',
  'integrations.admanager.application.create.success': 'User created in AD',
  'integrations.admanager.application.create.error': 'Unable to create user in AD',
  'integrations.admanager.application.notcreated': 'Not created in AD',
  'integrations.admanager.application.username.label': 'AD Username',
  'integrations.admanager.application.generatedby.label': 'Generated by',
  'integrations.admanager.applications.create.success': 'Task to create user in AD started',
  'integrations.admanager.applications.create.error': 'Unable to create users in AD',
  'integrations.admanager.modal.header': 'Create user in AD',
  'integrations.admanager.modal.template.label': 'Template name',
  'integrations.admanager.modal.button.submit': 'Create user',
  'integrations.admanager.bulkmodal.header': 'Create users in AD',
  'integrations.admanager.bulkmodal.note': 'Please note this might take a few minutes',
  'integrations.admanager.bulkmodal.button.submit': 'Create users',
  'integrations.admanager.filters.created': 'Is created in AD',
  'integrations.admanager.filters.notcreated': 'Is not created in AD',
  'integrations.admanager.filters.applied.created': 'Created',
  'integrations.admanager.bulk.send': 'Create users',
  'integrations.admanager.labels.created': 'AD Manager: Created',
  
  // OneCRM 
  'integrations.onecrm.applicants.retry.success': 'Application case successfully created in OneCRM',
  'integrations.onecrm.applicants.retry.fail': 'Unable to create application case in OneCRM',
  'integrations.onecrm.applicants.retry.button': 'Retry',
  'integrations.onecrm.applicants.confirm.button': 'Send',
  'integrations.onecrm.applicants.confirm.header': 'Send to OneCRM',
  'integrations.onecrm.applicants.confirm.main': 'You are about to send {0} applicant details to OneCRM',
  'integrations.onecrm.data_to_be_sent': 'Data that will be sent to OneCRM',
  'integrations.onecrm.job.applicants.cover': 'Cover letter',
  'integrations.onecrm.job.applicants.created': 'Created by',
  'integrations.onecrm.job.applicants.cv': 'CV / Resumé',
  'integrations.onecrm.job.applicants.files': 'Files',
  'integrations.onecrm.job.applicants.header': 'Applicant data',
  'integrations.onecrm.job.applicants.msg': 'Messages',
  'integrations.onecrm.job.applicants.qa': 'Questions and answers',
  'integrations.onecrm.job.applicants.send': 'Send to OneCRM',
  'integrations.onecrm.job.applicants.transfercomplete': 'Cases created',
  'integrations.onecrm.job.applicants.transfering': 'Creating cases',
  'integrations.onecrm.job.header': 'Create job case',
  'integrations.onecrm.jobcase.create.error': 'Unable to create job case in OneCRM.',
  'integrations.onecrm.jobcase.create.submit': 'Create job case',
  'integrations.onecrm.jobcase.create.success': 'Job case successfully created in OneCRM',
  'integrations.onecrm.jobcase.createdby': 'Created by',
  'integrations.onecrm.jobcase.files': 'Job files',
  'integrations.onecrm.jobcase.header': 'Job case',
  'integrations.onecrm.jobcase.info': 'Job info',
  'integrations.onecrm.jobcase.manager': 'Responsible',
  'integrations.onecrm.jobcase.notes': 'Job notes',
  'integrations.onecrm.jobcase.title': 'Title',
  'integrations.onecrm.onboarding.create.action': 'Create case',
  'integrations.onecrm.onboarding.create.error': 'Unable to hire case in OneCRM.',
  'integrations.onecrm.onboarding.create.label': 'Data to be sent over to OneCRM',
  'integrations.onecrm.onboarding.create.success': 'Hire case created',
  'integrations.onecrm.onboarding.create.title': 'Hire case',
  'integrations.onecrm.onboarding.gojobapp': 'Open job app',
  'integrations.onecrm.onboarding.jobcase.createdby': 'Created by',
  'integrations.onecrm.onboarding.jobcase.header': 'Job case',
  'integrations.onecrm.onboarding.jobcase.manager': 'Responsible',
  'integrations.onecrm.onboarding.jobcase.title': 'Title',
  'integrations.onecrm.onboarding.nojobcase': 'No job case found. A hire case cannot be created before a job case. Head on over to the Apps page for this job and create one, then try again.',
  'integrations.onecrm.onboarding.title': 'Create hire case',
  'integrations.onecrm.settings.applicationTemplate': 'Application case template',
  'integrations.onecrm.settings.connect': 'Connect',
  'integrations.onecrm.settings.create.error': 'Connection to OneCRM failed.',
  'integrations.onecrm.settings.create.success': 'Sucessfully connected to OneCRM',
  'integrations.onecrm.settings.idNumber': 'Company ID number in OneCRM',
  'integrations.onecrm.settings.jobTemplate': 'Job case template',
  'integrations.onecrm.settings.onboardingTemplate': 'Onboarding case template',
  'integrations.onecrm.settings.password': 'Password',
  'integrations.onecrm.settings.save': 'Save',
  'integrations.onecrm.settings.update.error': 'Unable to update OneCRM settings.',
  'integrations.onecrm.settings.update.success': 'OneCRM settings successfully updated',
  'integrations.onecrm.settings.url': 'OneCRM service URL',
  'integrations.onecrm.settings.username': 'Username',
  'integrations.onecrm.transfer.e': 'Error',
  'integrations.onecrm.transfer.n': 'No file found',
  'integrations.onecrm.transfer.p': 'Pending',
  'integrations.onecrm.transfer.s': 'Sent',

  // GetAccept
  'integrations.getaccept.settings.noauth': 'Welcome ⚡️. It looks like you haven\'t connected your GetAccept account with 50skills! If you press the button below, it will take you to a page on GetAccept were you can connect the two friends! 🧑‍💻👩‍💻 We\'ll be waiting for you!',
  'integrations.getaccept.settings.auth.button': 'Connect',
  'integrations.getaccept.settings.template.save.success': 'Template saved',
  'integrations.getaccept.settings.template.save.error': 'Template not saved, please contact 50skills',
  'integrations.getaccept.settings.templates.submit': 'Save',
  'integrations.getaccept.settings.authed': 'Nice going 🚀! Just follow the instruction below and you\'ll be signing documents in no time',
  'integrations.getaccept.settings.header': 'GetAccept',
  'integrations.getaccept.settings.header.settings': 'Settings',
  'integrations.getaccept.settings.needsapproval.label': 'Needs approval',
  'integrations.getaccept.settings.needsapprovallabel.label': 'Field label',
  'integrations.getaccept.settings.needsapproval.error': 'Field label is required when needs approval is checked',
  'integrations.getaccept.settings.save': 'Save settings',
  'integrations.getaccept.settings.save.success': 'Settings saved',
  'integrations.getaccept.settings.instructions.settings': 'If you want a user to approve each contract before the applicant signs, fill out the form below',
  'integrations.getaccept.settings.header.templates': 'Templates',
  'integrations.getaccept.settings.instructions.templates': 'Select a template below to to customize it',
  'integrations.getaccept.settings.instructions.notemplate': 'Whoops, no template found 👀. Head on over to GetAccept and create you first template! We\'ll be waiting ⏰',
  'integrations.getaccept.settings.subheader': 'Fields',
  'integrations.getaccept.settings.fields.instructions': 'Below are a list of fields the template contains, here you can map values from other apps or from the application itself. Don\'t worry, the user can always change the values later 🚀',
  'integrations.getaccept.settings.fields.instructions.nofields': 'It looks like this template doesn\'t contain any fields we can map to 🤷‍♀️. Maybe that was intentional, but if it wasn\'t, just hop onto GetAccept and add some fields! We\'ll be here when you\'re done 📝',
  'integrations.getaccept.settings.fields.clear': 'clear',

  // Onboarding Form
  'integrations.onboardingform.settings.header': 'Onboarding Form',
  'integrations.onboardingform.settings.sms': 'SMS message',
  'integrations.onboardingform.settings.sms.instructions': 'Send out an optional SMS notification and informational message to the applicants when you send them an onboarding form.',
  'integrations.onboardingform.settings.sms.tag': 'Extra',
  'integrations.onboardingform.settings.disabled': 'Disabled',
  'integrations.onboardingform.settings.enable': 'Enable',
  'integrations.onboardingform.settings.enabled': 'Enabled',
  'integrations.onboardingform.settings.sms.menu.edit': 'Edit message',
  'integrations.onboardingform.settings.sms.menu.disable': 'Disable SMS',
  'integrations.onboardingform.settings.sms.disable.toast': 'SMS notification disabled',
  'integrations.onboardingform.settings.sms.template.empty': 'SMS template can not be empty',
  'integrations.onboardingform.settings.sms.template.characters': '/320 characters used',
  'integrations.onboardingform.settings.email': 'Completion notification emails',
  'integrations.onboardingform.settings.email.instructions': 'Add additional email addresses for people that you would like to receive notification emails when applicants have completed their onboarding form. \nUsers who send out the forms always receive this notification.',
  'integrations.onboardingform.settings.email.recipients': 'Recipients:',
  'integrations.onboardingform.settings.email.applicant': 'Applicant completion notification email',
  'integrations.onboardingform.settings.email.applicant.instructions': 'Send out an optional email notification to the applicant when they have completed their onboarding form.',
  'integrations.onboardingform.settings.email.card.header': 'Email notification',
  'integrations.onboardingform.settings.email.menu.edit': 'Edit email',
  'integrations.onboardingform.settings.email.menu.disable': 'Disable email',
  'integrations.onboardingform.settings.email.get-templates.error': 'Error fetching email templates',
  'integrations.onboardingform.settings.email.create.success': 'Email template created',
  'integrations.onboardingform.settings.email.update.success': 'Email template updated',
  'integrations.onboardingform.settings.email.disable.success': 'Email disabled',
  'integrations.onboardingform.settings.email.disable.error': 'Error disabling email',
  'integrations.onboardingform.settings.email.disable.modal.header': 'Disable completion email',
  'integrations.onboardingform.settings.email.disable.modal.body': 'Users who sent out the form will no longer receive emails and recipients will be removed.\nAre you sure you want to disable this email?',
  'integrations.onboardingform.settings.email.disable.modal.disable': 'Disable',
  'integrations.onboardingform.settings.completion-email.modal.title': 'Completion notification email',
  'integrations.onboardingform.settings.completion-email.modal.title.edit': ' Edit completion notification email',
  'integrations.onboardingform.settings.completion-email.modal.description': 'Customize the email that will be sent to all recipients when an applicant has completed their onboarding form.',
  'integrations.onboardingform.settings.completion-email.applicant.modal.title': 'Applicant completion notification email',
  'integrations.onboardingform.settings.completion-email.applicant.modal.title.edit': ' Edit applicant completion notification email',
  'integrations.onboardingform.settings.completion-email.applicant.modal.description': 'Customize the email that will be sent to the applicant when they have completed their onboarding form.',
  'integrations.onboardingform.settings.completion-email.modal.emailsubject': 'Email subject',
  'integrations.onboardingform.settings.completion-email.modal.emailsubject.error': 'Email subject can not be empty',
  'integrations.onboardingform.settings.completion-email.modal.emailbody': 'Content',
  'integrations.onboardingform.settings.completion-email.modal.emailbody.error': 'Email body can not be empty',
  'integrations.onboardingform.settings.emails.error': 'Invalid email',
  'integrations.onboardingform.settings.submit': 'Add recipient',
  'integrations.onboardingform.settings.email.edit': 'Edit',
  'integrations.onboardingform.settings.email.remove': 'Remove recipient',
  'integrations.onboardingform.settings.emails.remove.success': 'Recipient removed',
  'integrations.onboardingform.settings.save.success': 'App saved',
  'integrations.onboardingform.settings.save.error': 'App not saved, please contact 50skills',
  'integrations.onboardingform.settings.add.modal.title': 'Add notification recipient',
  'integrations.onboardingform.settings.add.modal.name': 'Name',
  'integrations.onboardingform.settings.add.modal.email': 'Email',
  'integrations.onboardingform.settings.add.modal.recipient.added.toast': 'Recipient added',
  'integrations.onboardingform.settings.add.modal.name.missing': 'Name is missing',
  'integrations.onboardingform.settings.edit.modal.title': 'Edit notification recipient',
  'integrations.onboardingform.settings.edit.modal.recipient.changed.toast': 'Recipient changed',
  'integrations.onboardingform.bulk.send': 'Send onboarding forms',
  'integrations.onboardingform.bulk.modal.noapplicants': 'There are no valid applicants in the selection you have made. Please make sure the applications are marked as hired and have not already been sent an onboarding form',
  'integrations.onboardingform.bulk.modal.info': 'Please note, only applications that have not already been sent an onboarding form will be included in this action',
  'integrations.onboardingform.bulk.modal.header': 'Send onboarding forms',
  'integrations.onboardingform.bulk.modal.send.header': 'Send an onboarding form to applicant/s',
  'integrations.onboardingform.bulk.modal.sent.header': 'Sending',
  'integrations.onboardingform.bulk.modal.sent.text': 'This action is being processed. Please note this might take a few minutes',
  'integrations.onboardingform.bulk.modal.send.error': 'Something went wrong, please contact 50skills support',
  'integrations.onboardingform.bulk.modal.templates.label': 'Select template to use',
  'integrations.onboardingform.bulk.modal.submit': 'Send onboarding forms',
  'integrations.onboardingform.sms.modal.subheader': 'Customize the SMS message you want to send to your applicants. Use variable {{url}} for direct url to applicants onboarding form.',
  'integrations.onboardingform.sms.modal.label': 'Message',
  'integrations.onboardingform.sms.modal.helptext': 'For best deliverability, 320 characters or less is recommmended',
  'integrations.onboardingform.sms.modal.initialtext': 'Hi, we have just sent you a new employee form to fill out, <br>please visit {{url}} to start your onboarding process. <br>we have also sent you a link to your email. <br>Best regards',
  'integrations.onboardingform.sms.modal.cancel': 'Cancel',
  'integrations.onboardingform.sms.modal.save': 'Save',
  'integrations.onboardingform.sms.modal.save.toast': 'SMS message saved',
  'integrations.onboardingform.sms.modal.messagelong': 'SMS message too long',
  'integrations.onboardingform.form.template.label': 'Select form',
  'integrations.onboardingform.form.email': 'E-mail',
  'integrations.onboardingform.form.sendsms': 'Send SMS',
  'integrations.onboardingform.form.datesent': 'Date sent',
  'integrations.onboardingform.form.dateCompleted': 'Date completed',
  'integrations.onboardingform.form.sentto.mail': 'Sent to • Mail',
  'integrations.onboardingform.form.sentto.sms': 'Sent to • SMS',
  'integrations.onboardingform.form.sentby': 'Sent by',
  'integrations.onboardingform.form.inprogress': 'In progress',
  'integrations.onboardingform.form.completed': 'Completed',
  'integrations.onboardingform.form.resend': 'Resend',
  'integrations.onboardingform.form.answer.missing': 'Answer not provided',
  'integrations.onboardingform.form.tooltip.remove': 'Remove form',
  'integrations.onboardingform.form.tooltip.copylink': 'Copy link to form',
  'integrations.onboardingform.form.tooltip.resend': 'Resend form',
  'integrations.onboardingform.form.copied.toast': 'Link copied',
  'integrations.onboardingform.form.sent.toast': 'Onboarding form successfully sent',
  'integrations.onboardingform.form.error.toast': 'Onboarding form error. Please contact 50skills support.',
  'integrations.onboardingform.form.error.email.invalid': 'Invalid email',
  'integrations.onboardingform.form.error.phone.missing': 'Phone number is missing, uncheck "Send SMS" or add phone number',
  'integrations.onboardingform.form.error.template.missing': 'Form missing',
  'integrations.onboardingform.resend.modal.header': 'Resend onboarding form',
  'integrations.onboardingform.save.no.phone.error': 'The phone field can not be empty if send SMS is checked',
  'integrations.onboardingform.template.none': 'No templates available',
  'integrations.onboardingform.integrationHeader.title': 'Onboarding form',
  'integrations.onboardingform.integrationHeader.description': 'Send a new employee an onboarding form',

  // Onboarding Form RU
  "integrations.ru.onboardingform.add.signee": "Add another signee",
  "integrations.ru.onboardingform.register.to.union": "Register employee to union",
  "integrations.ru.onboardingform.send.to.esigning": "Send contract for signing with electronic ID",
  "integrations.ru.onboardingform.signee.email": "Signee's email (HR)",
  "integrations.ru.onboardingform.signee.name": "Signee on behalf of HR",
  "integrations.ru.onboardingform.signee.phone": "Signee's phone",
  "integrations.ru.onboardingform.signee.ssn": "Signee's SSN (HR)",


  // Kjarni
  'integrations.kjarni.settings.header': 'Kjarni',
  'integrations.kjarni.settings.instructions': 'Welcome ⚡️. Here you can add email addresses that should always be notified when the form has been completed.',
  'integrations.kjarni.settings.emails.label': 'Emails',
  'integrations.kjarni.settings.emails.error': 'Invalid email',
  'integrations.kjarni.settings.submit': 'Save',
  'integrations.kjarni.settings.save.success': 'App saved',
  'integrations.kjarni.settings.save.error': 'App not saved, please contact 50skills',

  // Asana
  'integrations.asana.settings.header': 'Asana',
  'integrations.asana.settings.header.token': 'Token set',
  'integrations.asana.settings.header.notoken': 'Token not set',
  'integrations.asana.settings.instructions.header.sub': 'If you are using Asana for onboarding you can track the process of finished tasks directly in 50skills in sync with other onboarding tasks.',
  'integrations.asana.settings.instructions.step1.header': 'Connecting 50skills and Asana',
  'integrations.asana.settings.instructions.step1.sub_header': 'A) Create a new user in Asana with the name 50skills',
  'integrations.asana.settings.instructions.step1': 'This user will be in charge of creating projects, so make sure the user has access to all teams that need onboarding projects',
  'integrations.asana.settings.instructions.step2.sub_header': 'B) Log in as that user',
  'integrations.asana.settings.instructions.step2.1': 'Go to My Profile Settings > Apps > Manage Developer Apps, or go to ',
  'integrations.asana.settings.instructions.step2.2': 'Under Personal access tokens click “New access token”.',
  'integrations.asana.settings.instructions.step2.3': 'Name the token 50skills and agree to the terms.',
  'integrations.asana.settings.instructions.step3.sub_header': 'C) Add token to 50skills',
  'integrations.asana.settings.instructions.step3': 'Copy the token, and paste it above in the TOKEN field in 50skills and press Save. We will hide the Token info for other users.',
  'integrations.asana.settings.token.label': 'Token',
  'integrations.asana.settings.submit': 'Save',
  'integrations.asana.settings.save.success': 'App saved',
  'integrations.asana.settings.save.error': 'App not saved, please contact 50skills',

  // HR Monitor
  'integrations.hrmonitor.settings.header': 'HR Monitor',
  'integrations.hrmonitor.settings.header.connected': 'Connected',
  'integrations.hrmonitor.settings.header.notconnected': 'Not connected',
  'integrations.hrmonitor.settings.info': 'Listen, measure and bring out the best in your people',
  'integrations.hrmonitor.settings.connect': 'Connect',
  'integrations.hrmonitor.settings.save.success': 'App connected',
  'integrations.hrmonitor.settings.save.error': 'App not connected, please contact 50skills',

  // Relesys
  'integrations.relesys.settings.header': 'Relesys',
  'integrations.relesys.settings.header.clientsecret': 'Connected',
  'integrations.relesys.settings.header.noclientsecret': 'Not connected',
  'integrations.relesys.settings.instructions.header': 'Introduction',
  'integrations.relesys.settings.instructions.content': 'You can integrate 50skills and Relesys to make it easy to add new hires into the Relesys Communication & Performance Platform.',
  'integrations.relesys.settings.gettingaccess.header': 'Getting access',
  'integrations.relesys.settings.gettingaccess.content': 'In order to access the Relesys API, you need to get hold of a Client ID and a Client Secret. These are provided by Relesys. Please contact your relevant client manager, or contact support@relesys.net for further assistance.',
  'integrations.relesys.settings.howtoconnect.header': 'How to connect',
  'integrations.relesys.settings.howtoconnect.content': 'Once you gotten the Client ID and Client Secret, insert it into the form above, and click Connect.',
  'integrations.relesys.settings.clientid.label': 'Client ID',
  'integrations.relesys.settings.clientsecret.label': 'Client Secret',
  'integrations.relesys.settings.smstext.label': 'SMS Text',
  'integrations.relesys.settings.submit': 'Save',
  'integrations.relesys.settings.save.success': 'App saved',
  'integrations.relesys.settings.save.error': 'App not saved, please contact 50skills',

  // Slack
  'integrations.slack.settings.header.connected': 'Connected',
  'integrations.slack.settings.header.notconnected': 'Not connected',
  'integrations.slack.settings.info': 'Get instant notifications in Slack when using key events in 50skills:',
  'integrations.slack.settings.info.a': 'A) Creates a private channel for each job you create and automatically invites your hiring team to it',
  'integrations.slack.settings.info.b': 'B) Get notified when new applicants apply',
  'integrations.slack.settings.info.c': 'C) Get notified when team members write notes about applicants',
  'integrations.slack.settings.info.d': 'D) Send unique referral links to team members of any public Slack channel',
  'integrations.slack.settings.buttons.connect': 'Connect',
  'integrations.slack.settings.buttons.reconnect': 'Re-connect',
  'integrations.slack.settings.buttons.learnmore': 'Learn more',

  // Signet
  'integrations.signet.button.submit': 'Send',
  'integrations.signet.button.document.add': 'Add document',
  'integrations.signet.templates.options.empty': 'No templates to send',
  'integrations.signet.settings.header.connected': 'Connected',
  'integrations.signet.settings.header.notconnected': 'Not connected',
  'integrations.signet.settings.description': 'Here you can connect your Signet account so you can send out documents to e-signing directly from 50skills.',
  'integrations.signet.settings.modal.reconnect': 'Reconnect',
  'integrations.signet.settings.modal.connect': 'Connect',
  'integrations.signet.settings.connect.modal.username.label': 'Username',
  'integrations.signet.settings.connect.modal.password.label': 'Password',
  'integrations.signet.settings.connect.modal.certificatepassword.label': 'Certificate password',
  'integrations.signet.settings.connect.modal.certificate.label': 'Certificate',
  'integrations.signet.settings.connect.modal.header': 'Connect Signet',
  'integrations.signet.settings.connect.modal.description': 'Insert the data for your company in the field below and you should be connected. If you are unsure what your data is please contact your Signet account manager.',
  'integrations.signet.settings.connect.modal.connect': 'Connect',
  'integrations.signet.settings.connect.modal.cancel': 'Cancel',
  'integrations.signet.settings.connect.modal.saved': 'Data saved',
  'integrations.signet.settings.connect.modal.error': 'Unable to save data, are you sure it is correct?',
  'integrations.signet.settings.cosigners.description': 'You are now connected to Signet! In order to send out documents you need to add Cosigners for your company, here below you can manage the cosigners. These individuals will be selectable as cosigners from a list before a contract is sent out to the new employee.',
  'integrations.signet.settings.cosigners': 'Cosigners',
  'integrations.signet.settings.cosigners.add': 'Add cosigner',
  'integrations.signet.settings.cosigners.none': 'No cosigners added',
  'integrations.signet.settings.cosigners.edit': 'Edit',
  'integrations.signet.settings.cosigners.delete': 'Remove',
  'integrations.signet.settings.cosigners.remove.success': 'Cosigner removed',
  'integrations.signet.settings.cosigners.modal.header': 'Add cosigner',
  'integrations.signet.settings.cosigners.modal.edit.header': 'Edit cosigner',
  'integrations.signet.settings.cosigners.modal.name.label': 'Name',
  'integrations.signet.settings.cosigners.modal.email.label': 'Email',
  'integrations.signet.settings.cosigners.modal.ssn.label': 'SSN / ID number',
  'integrations.signet.settings.cosigners.modal.cancel': 'Cancel',
  'integrations.signet.settings.cosigners.modal.submit': 'Add',
  'integrations.signet.settings.cosigners.modal.save': 'Save',
  'integrations.signet.settings.cosigners.modal.error': 'Unable to save data, are you sure it is correct?',
  'integrations.signet.settings.cosigners.add.success': 'Cosigner added',
  'integrations.signet.settings.cosigners.edit.success': 'Cosigner saved',
  'integrations.signet.settings.credentials.expired': 'Your credentials have expired, please reconnect to re-enable this integration.',

  // Taktikal
  'integrations.taktikal.button.submit': 'Send',
  'integrations.taktikal.button.document.add': 'Add document',
  'integrations.taktikal.settings.header.connected': 'Connected',
  'integrations.taktikal.settings.header.notconnected': 'Not connected',
  'integrations.taktikal.settings.description': 'Here you can connect your Taktikal account so you can send out documents to e-signing directly from 50skills.',
  'integrations.taktikal.settings.modal.connect': 'Connect',
  'integrations.taktikal.settings.connect.modal.header': 'Connect Taktikal',
  'integrations.taktikal.settings.connect.modal.description': 'Insert the keys for your company in the field below and you should be connected. If you are unsure what your keys are please contact your Taktikal account manager.',
  'integrations.taktikal.settings.connect.modal.flowkey.label': 'Flow key',
  'integrations.taktikal.settings.connect.modal.apikey.label': 'Api key',
  'integrations.taktikal.settings.connect.modal.companykey.label': 'Company key',
  'integrations.taktikal.settings.connect.modal.connect': 'Connect',
  'integrations.taktikal.settings.connect.modal.cancel': 'Cancel',
  'integrations.taktikal.settings.connect.modal.saved': 'Keys saved',
  'integrations.taktikal.settings.connect.modal.error': 'Unable to save keys, are you sure it is correct?',
  'integrations.taktikal.settings.cosigners.description': 'You are now connected to Taktikal! In order to send out documents you need to add Cosigners for your company, here below you can manage the cosigners. These individuals will be selectable as cosigners from a list before a contract is sent out to the new employee.',
  'integrations.taktikal.settings.cosigners': 'Cosigners',
  'integrations.taktikal.settings.cosigners.add': 'Add cosigner',
  'integrations.taktikal.settings.cosigners.none': 'No cosigners added',
  'integrations.taktikal.settings.cosigners.reconnect': 'Reconnect',
  'integrations.taktikal.settings.cosigners.modal.header': 'Add cosigner',
  'integrations.taktikal.settings.cosigners.modal.edit.header': 'Edit cosigner',
  'integrations.taktikal.settings.cosigners.modal.name.label': 'Name',
  'integrations.taktikal.settings.cosigners.modal.email.label': 'Email',
  'integrations.taktikal.settings.cosigners.modal.ssn.label': 'SSN / ID number',
  'integrations.taktikal.settings.cosigners.modal.phone.label': 'Phone number',
  'integrations.taktikal.settings.cosigners.modal.cancel': 'Cancel',
  'integrations.taktikal.settings.cosigners.modal.submit': 'Add',
  'integrations.taktikal.settings.cosigners.modal.save': 'Save',
  'integrations.taktikal.settings.cosigners.modal.error': 'Unable to save data, are you sure it is correct?',
  'integrations.taktikal.settings.cosigners.add.success': 'Cosigner added',
  'integrations.taktikal.settings.cosigners.edit.success': 'Cosigner saved',
  'integrations.taktikal.settings.cosigners.remove.success': 'Cosigner removed',
  'integrations.taktikal.settings.cosigners.edit': 'Edit',
  'integrations.taktikal.settings.cosigners.delete': 'Remove',
  'integrations.taktikal.signaturelocation.label': 'Signature location',
  'integrations.taktikal.signaturelocation.topfirstpage': 'Top of first page',
  'integrations.taktikal.signaturelocation.bottomlastpage': 'Bottom of last page',
  'integrations.taktikal.signaturelocation.success': 'Signature location changed',
  'integrations.taktikal.signaturelocation.error': 'Unable to save signature location',
  
  // Siminn Pay
  'application.onboarding.integration.siminnpay.sendinvite': 'Send invite',

  // Teachable
  'application.onboarding.integration.teachable.sendinvite': 'Send invite',

  // Eloomi
  'application.onboarding.integration.eloomi.submit': 'Create user',

  // Hireflix
  'integrations.hireflix.job.app.form.description': 'Link a Hireflix position to this job',
  'integrations.hireflix.job.app.form.position.label': 'Position',
  'integrations.hireflix.job.app.form.save': 'Save',
  'integrations.hireflix.job.app.info.position.label': 'Position',
  'integrations.hireflix.job.app.info.notifications.label': 'Notifications',
  'integrations.hireflix.job.app.info.notifications.email': 'Email',
  'integrations.hireflix.job.app.info.notifications.sms': 'SMS',
  'integrations.hireflix.job.app.info.notifications.whatsapp': 'WhatsApp',
  'integrations.hireflix.job.app.info.notifications.type.immediately': 'Sent immediately',
  'integrations.hireflix.job.app.info.notifications.type.afterhours': 'After {0} hours',
  'integrations.hireflix.job.app.info.sent.label': 'Interviews sent',
  'integrations.hireflix.job.app.info.completed.label': 'Interviews completed',
  'integrations.hireflix.job.app.info.remove.label': 'Unlink',
  'integrations.hireflix.job.app.nopositions': 'No positions available in Hireflix. Please add a position over there and then come back here ⚡️',
  'integrations.hireflix.application.noapps': 'No candidate job apps enabled',
  'integrations.hireflix.application.linkposition': 'Link position',
  'integrations.hireflix.application.jobnotlinked': 'No position assigned to this job',
  'integrations.hireflix.application.sendinterview': 'Send interview',
  'integrations.hireflix.application.interviewnotsent': 'No interview sent',
  'integrations.hireflix.application.sentby.label': 'Sent by',
  'integrations.hireflix.application.status.label': 'Status',
  'integrations.hireflix.application.status.invited': 'Invited',
  'integrations.hireflix.application.status.completed': 'Completed',
  'integrations.hireflix.application.status.sent': 'Interview sent',
  'integrations.hireflix.application.status.toevaluate': 'To evaluate',
  'integrations.hireflix.application.status.preselected': 'Pre-selected',
  'integrations.hireflix.application.status.discarded': 'Discarded',
  'integrations.hireflix.application.status.error': 'Unable to change status',
  'integrations.hireflix.application.delete.confirm': 'Are you sure you want to delete this interview? It will also delete the interview in Hireflix',
  'integrations.hireflix.application.delete.success': 'Interview removed',
  'integrations.hireflix.application.delete.error': 'Unable to remove interview',
  'integrations.hireflix.application.ratings.received': 'Ratings received • {0}',
  'integrations.hireflix.application.ratings.viewall': 'View ratings',
  'integrations.hireflix.application.rating.overall': 'Overall rating',
  'integrations.hireflix.application.rating.strongno': 'Strong no • 0',
  'integrations.hireflix.application.rating.no': 'No • 2.5',
  'integrations.hireflix.application.rating.average': 'Average • 5',
  'integrations.hireflix.application.rating.yes': 'Yes • 7.5',
  'integrations.hireflix.application.rating.strongyes': 'Strong yes • 10',
  'integrations.hireflix.application.question.rating.error': 'Unable to add rating',
  'integrations.hireflix.application.modal.header': 'Send Hireflix interview',
  'integrations.hireflix.application.modal.position.label': 'Position',
  'integrations.hireflix.application.modal.notifications.label': 'Notifications',
  'integrations.hireflix.application.modal.submit': 'Send interview',
  'integrations.hireflix.application.modals.reviews.header': 'Reviews',
  "integrations.hireflix.application.no.answer.found" : 'No answer video found',
  'integrations.hireflix.errors.invalidapikey': 'API Key is invalid. Please check the Hireflix settings page',
  'integrations.hireflix.errors.candidatealreadyexists': 'Candidate with this email already exists on this position',
  'integrations.hireflix.errors.expiredaccount': 'You Hireflix account has expired',
  'integrations.hireflix.settings.description': 'Welcome, here you will put the API key you can find on the Hireflix website. In order to get your API key, go to Your account -> API Keys and copy-paste the API key on to this form.',
  'integrations.hireflix.settings.apikey.label': 'API Key',
  'integrations.hireflix.settings.submit.label': 'Submit',
  'integrations.hireflix.settings.save.success': 'Settings saved',
  'integrations.hireflix.filters.title': 'Hireflix',
  'integrations.hireflix.filters.rating': 'Rating',
  'integrations.hireflix.filters.status': 'Status',
  'integrations.hireflix.filters.status.sent': 'Interview sent',
  'integrations.hireflix.filters.status.completed': 'To evaluate',
  'integrations.hireflix.filters.status.finalist': 'Pre-selected',
  'integrations.hireflix.filters.status.archived': 'Discarded',
  'integrations.hireflix.filters.date_sent': 'Date sent',
  'integrations.hireflix.bulk.invite': 'Send interviews',
  'integrations.hireflix.bulk.modal.send.header': 'Send an interview to applicant/s',
  'integrations.hireflix.bulk.modal.sent.header': 'Sending',
  'integrations.hireflix.bulk.modal.sent.text': 'This action is being processed. Please note this might take a few minutes',
  'integrations.hireflix.bulk.modal.send.error': 'Something went wrong, please contact 50skills support',

  // H3Core
  'integrations.h3core.settings.description': 'Welcome, here you you will input info about your H3Core service. If you do not have this info, please contact your Advania contact. When you have successfully submitted the info, you can contact 50skills',
  'integrations.h3core.settings.url.label': 'Base URL',
  'integrations.h3core.settings.companyname.label': 'Company Name',
  'integrations.h3core.settings.username.label': 'Username',
  'integrations.h3core.settings.password.label': 'Password',
  'integrations.h3core.settings.submit.label': 'Submit',
  'integrations.h3core.settings.save.success': 'Settings saved',
  'integrations.h3core.errors.sslcertificateerror': 'SSL Certificate error. Most likely reason: Certificate misconfigured',
  'integrations.h3core.errors.noconnection': 'Unable to establish connection. Most likely reason: IP addresses not whitelisted',
  'integrations.h3core.errors.unknownerror': 'Unknown error. Please contact Advania',
  'integrations.h3core.errors.authfailed': 'Authentication error. Are the credentials correct?',
  'integrations.h3core.errors.notnullvalue': 'Error from H3Core. Most likely reason: Either the company name does not exist or the user does not have access to it.',
  'integrations.h3core.errors.notfound': 'URL not found. Are sure the URL is correct?',
  'integrations.h3core.errors.emptyresponse': 'Empty response from H3Core. Please contact Advania',
  'integrations.h3core.bulk.edit': 'Bulk edit H3',
  'integrations.h3core.bulk.create': 'Bulk create in H3',

  // Journeys
  'integrations.journeys.bulk.create': 'Add to Journey',
  'integrations.journeys.stage.addTrigger': 'Add Journey stage trigger',

  // Timon
  'integrations.timon.settings.connected': 'Connected',
  'integrations.timon.settings.description': 'Welcome, here you you will input info about your Tímon service. If you do not have this info, please contact your Trackwell contact. When you have successfully submitted the info, the app should be ready to use',
  'integrations.timon.settings.url.label': 'API URL',
  'integrations.timon.settings.username.label': 'Username',
  'integrations.timon.settings.password.label': 'Password',
  'integrations.timon.settings.submit.label': 'Submit',
  'integrations.timon.settings.save.success': 'Settings saved',

  // MyTimePlan
  'integrations.mytimeplan.settings.connected': 'Connected',
  'integrations.mytimeplan.settings.description': 'Welcome, here you you will input info about your MyTimePlan service. If you do not have this info, please contact your MyTimePlan contact. When you have successfully submitted the info, the app should be ready to use',
  'integrations.mytimeplan.settings.url.label': 'API URL',
  'integrations.mytimeplan.settings.username.label': 'Username',
  'integrations.mytimeplan.settings.password.label': 'Password',
  'integrations.mytimeplan.settings.submit.label': 'Submit',
  'integrations.mytimeplan.settings.save.success': 'Settings saved',

  // Dokobit
  'integrations.dokobit.settings.description': 'Here you can connect your Dokobit account so you can send out documents to e-signing directly from 50skills. Insert the API token for your company in the field below and you should be connected. If you are unsure what your token is please contact your Dokobit account manager',
  'integrations.dokobit.settings.token.label': 'Token',
  'integrations.dokobit.settings.token.submit': 'Submit',
  'integrations.dokobit.settings.token.saved': 'Token saved',
  'integrations.dokobit.settings.token.error': 'Unable to save token, are you sure it is correct?',
  'integrations.dokobit.settings.cosigners.description': 'You are now connected to Dokobit! In order to send out documents you need to add Cosigners for your company, here below you can manage the cosigners. These individuals will be selectable as cosigners from a list before a contract is sent out to the new employee.',
  'integrations.dokobit.settings.cosigners': 'Cosigners',
  'integrations.dokobit.settings.cosigners.none.header': 'No cosigners',
  'integrations.dokobit.settings.cosigners.none.content': 'Add some cosigners by pressing the + button above',
  'integrations.dokobit.settings.cosigners.add': 'Add cosigner',
  'integrations.dokobit.settings.cosigners.edit': 'Edit',
  'integrations.dokobit.settings.cosigners.delete': 'Remove',
  'integrations.dokobit.settings.cosigners.modal.header': 'Add cosigner',
  'integrations.dokobit.settings.cosigners.modal.edit.header': 'Edit cosigner',
  'integrations.dokobit.settings.cosigners.modal.name.label': 'Name',
  'integrations.dokobit.settings.cosigners.modal.email.label': 'Email',
  'integrations.dokobit.settings.cosigners.modal.ssn.label': 'SSN / ID number',
  'integrations.dokobit.settings.cosigners.modal.phone.label': 'Phone number',
  'integrations.dokobit.settings.cosigners.modal.cancel': 'Cancel',
  'integrations.dokobit.settings.cosigners.modal.submit': 'Add',
  'integrations.dokobit.settings.cosigners.modal.save': 'Save',
  'integrations.dokobit.settings.cosigners.add.success': 'Cosigner added',
  'integrations.dokobit.settings.cosigners.edit.success': 'Cosigner saved',
  'integrations.dokobit.settings.cosigners.remove.success': 'Cosigner removed',
  'integrations.dokobit.onboarding.form.template.none': 'No templates available',
  'integrations.dokobit.onboarding.form.template.label': 'Template',
  'integrations.dokobit.onboarding.form.template.error': 'Error fetching template',
  'integrations.dokobit.onboarding.form.document.cancel': 'Cancel',
  'integrations.dokobit.onboarding.form.document.add': 'Add document',
  'integrations.dokobit.onboarding.form.success': 'Contract sent to signing',
  'integrations.dokobit.onboarding.form.saved': 'Information saved',
  'integrations.dokobit.onboarding.form.deleted': 'Information deleted',
  'integrations.dokobit.onboarding.form.cosigners.placeholder': 'Cosigners',
  'integrations.dokobit.onboarding.form.cosigners.label': 'Select cosigners',
  'integrations.dokobit.onboarding.form.cosigners.nooptions': 'No more cosigners available',
  'integrations.dokobit.onboarding.form.submit': 'Send',
  'integrations.dokobit.onboarding.form.save': 'Save',
  'integrations.dokobit.onboarding.form.save.saved': 'Saved',
  'integrations.dokobit.onboarding.form.errors.title': 'Dokobit returned the following errors:',
  'integrations.dokobit.onboarding.contract.delete.notification': 'Contract deleted',
  'integrations.dokobit.onboarding.contract.document.label': 'Document',
  'integrations.dokobit.onboarding.contract.datesent.label': 'Date sent',
  'integrations.dokobit.onboarding.contract.sentby.label': 'Sent by',
  'integrations.dokobit.onboarding.contract.signer.label': 'Signer • {0}',
  'integrations.dokobit.onboarding.contract.signer.signed': 'Signed',
  'integrations.dokobit.onboarding.contract.signer.pending': 'Waiting for response',
  'integrations.dokobit.onboarding.contract.signer.declined': 'Declined',
  'integrations.dokobit.onboarding.info.remove': 'Remove document',
  'integrations.dokobit.onboarding.info.remove.description': 'Are you sure you want to remove this document?',
  'integrations.dokobit.onboarding.info.delete': 'Delete document',
  'integrations.dokobit.onboarding.info.delete.description': 'Are you sure you want to delete this document? It has already been sent and it will be removed for all signers',
  'integrations.dokobit.signaturelocation.label': 'Signature location',
  'integrations.dokobit.signaturelocation.topfirstpage': 'Top of first page',
  'integrations.dokobit.signaturelocation.bottomfirstpage': 'Bottom of first page',
  'integrations.dokobit.signaturelocation.toplastpage': 'Top of last page',
  'integrations.dokobit.signaturelocation.bottomlastpage': 'Bottom of last page',
  'integrations.dokobit.signaturelocation.success': 'Signature location changed',
  'integrations.dokobit.signaturelocation.error': 'Unable to save signature location',

  'jobboards.tvinna.title.status': 'Employment type',
  'jobboards.tvinna.title.extra': 'Extra info',
  'jobboards.tvinna.info': 'Information about Tvinna',
  'jobboards.hi.info': 'Information about Tengslatorg HÍ',
  'jobboards.jobdotis.info': 'Information about Job.is',

  'jobboards.post.heading': 'Post job to {0}',
  'jobboards.post.language': 'Language',
  'jobboards.post.back': 'Back',
  'jobboards.post.go': 'Post to job board',
  'jobboards.post.example': 'What will the ad look like?',
  'jobboards.select.heading': 'Select job board to post to',
  'jobboards.select.cancel': 'Cancel',
  'jobboards.select.go': 'Continue',
  'jobboards.list.view': 'View',
  'jobboards.table.jobboard': 'Job board',
  'jobboards.table.price': 'Price',
  'jobboards.table.link': 'Link',
  'jobboards.table.user': 'User',
  'jobboards.table.options': 'Options',
  'jobboards.table.posted': 'Posted',
  'jobboards.postlist.header': 'Posts on job boards',
  'jobboards.postlist.text': 'Drive traffic to your job posts by posting directly to public job boards.',
  'jobboards.settings.connected': 'Connected job boards',
  'jobboards.settings.available': 'Available job boards',
  'jobboards.settings.noc': 'No job boards connected',
  'jobboards.settings.nocText': 'Connect 50skills with job boards so that you can post directly to them for each job within 50skills',
  'jobboards.settings.btn.disconnect': 'Disconnect',
  'jobboards.settings.btn.connect': 'Connect',
  'jobboards.connect.success': 'Successfully activated job board.',
  'jobboards.connect.error': 'Could not activated job board. Please contact 50skills support.',
  'jobboards.disconnect.success': 'Successfully deactivated job board.',
  'jobboards.disconnect.error': 'Could not deactivated job board. Please contact 50skills support.',
  'jobboards.create': 'Post to job board',
  'jobboards.submit.success': 'Successfully posted job {0} to job board {1}.',
  'jobboards.submit.error': 'Unable to post job {0} to job board {1}. Please contact 50skills support.',
  'jobboards.emptyposts.heading': 'No posts on job boards',
  'jobboards.emptyposts.text': 'Want more visibility? Connect your favorite job-boards and post job openings to them directly from 50skills.',
  'jobboards.emptyboards.heading': 'No job boards connected',
  'jobboards.emptyboards.text': 'Job boards need to be connected in company settings before posting.',
  'jobboards.emptyboards.btn': 'Connect job boards',
  'jobboards.list.menu.remove': 'Delete post',
  'jobboards.removepost.success': 'Job board post successfully deleted',
  'jobboards.removepost.error': 'Unable to delete job post. Please contact 50skills support.',

  'pipeline.tooltip.rating': 'Applicant has been rated 1 time.',
  'pipeline.tooltip.ratings': 'Applicant has been rated {0} times.',
  'pipeline.tooltip.note': 'Applicant has 1 note.',
  'pipeline.tooltip.notes': 'Applicant has {0} notes.',
  'pipeline.tooltip.file': 'Applicant has 1 attached file.',
  'pipeline.tooltip.files': 'Applicant has {0} attached files.',
  'pipeline.tooltip.message': 'Applicant has 1 message.',
  'pipeline.tooltip.messages': 'Applicant has {0} messages.',
  'pipeline.tooltip.assignee': 'Applicant has been assigned to {0}.',
  'pipeline.tooltip.tasklist': 'The onboarding tasklist for this applicant has 1 unfinished task.',
  'pipeline.tooltip.tasklists': 'The onboarding tasklist for this applicant has {0} unfinished tasks.',

  'company.apps.filters.header': 'New employees',
  'company.apps.filters.sub_header': 'Filter by conditional settings',
  'company.apps.filters.search.placeholder': 'Search by name',
  'company.apps.filters.all': 'All',

  'ssnregistry.gender.1': 'Male',
  'ssnregistry.gender.2': 'Female',
  'ssnregistry.gender.3': 'Male',
  'ssnregistry.gender.4': 'Female',
  'ssnregistry.gender.7': 'Other',
  'ssnregistry.gender.8': 'Other',

  'maintenance.header': 'Maintenance',
  'maintenance.message': '50skills is undergoing scheduled maintenance right now and will be back better, faster and stronger than ever in just a moment. We sincerely apologize for the inconvenience.',
  'maintenance.info': 'The maintenance only applies to the admin interface and you will continue receiving applications as normal throughout this downtime.',
  'maintenance.thanks': 'Thank you for your patience.',
  'maintenance.button': 'Contact support',

  'applicants_columns.review.sort.asc': 'Sort Lowest → Highest',
  'applicants_columns.review.sort.desc': 'Sort Highest → Lowest'
};
